import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  firstname: Scalars['String'];
  id: Scalars['ID'];
  lastname: Scalars['String'];
  username?: Maybe<Scalars['String']>;
};

export type Agency = {
  __typename?: 'Agency';
  address?: Maybe<Scalars['String']>;
  agents?: Maybe<Array<Maybe<Agent>>>;
  created_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<UploadFile>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
  website?: Maybe<Scalars['String']>;
};


export type AgencyAgentsArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type AgencyAggregator = {
  __typename?: 'AgencyAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AgencyConnection = {
  __typename?: 'AgencyConnection';
  aggregate?: Maybe<AgencyAggregator>;
  groupBy?: Maybe<AgencyGroupBy>;
  values?: Maybe<Array<Maybe<Agency>>>;
};

export type AgencyConnectionAddress = {
  __typename?: 'AgencyConnectionAddress';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgencyConnectionCreated_At = {
  __typename?: 'AgencyConnectionCreated_at';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AgencyConnectionDescription = {
  __typename?: 'AgencyConnectionDescription';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgencyConnectionEmail = {
  __typename?: 'AgencyConnectionEmail';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgencyConnectionId = {
  __typename?: 'AgencyConnectionId';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AgencyConnectionLogo = {
  __typename?: 'AgencyConnectionLogo';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AgencyConnectionName = {
  __typename?: 'AgencyConnectionName';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgencyConnectionPhone_Number = {
  __typename?: 'AgencyConnectionPhone_number';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgencyConnectionPublished_At = {
  __typename?: 'AgencyConnectionPublished_at';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AgencyConnectionUpdated_At = {
  __typename?: 'AgencyConnectionUpdated_at';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AgencyConnectionWebsite = {
  __typename?: 'AgencyConnectionWebsite';
  connection?: Maybe<AgencyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgencyGroupBy = {
  __typename?: 'AgencyGroupBy';
  address?: Maybe<Array<Maybe<AgencyConnectionAddress>>>;
  created_at?: Maybe<Array<Maybe<AgencyConnectionCreated_At>>>;
  description?: Maybe<Array<Maybe<AgencyConnectionDescription>>>;
  email?: Maybe<Array<Maybe<AgencyConnectionEmail>>>;
  id?: Maybe<Array<Maybe<AgencyConnectionId>>>;
  logo?: Maybe<Array<Maybe<AgencyConnectionLogo>>>;
  name?: Maybe<Array<Maybe<AgencyConnectionName>>>;
  phone_number?: Maybe<Array<Maybe<AgencyConnectionPhone_Number>>>;
  published_at?: Maybe<Array<Maybe<AgencyConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<AgencyConnectionUpdated_At>>>;
  website?: Maybe<Array<Maybe<AgencyConnectionWebsite>>>;
};

export type AgencyInput = {
  address?: Maybe<Scalars['String']>;
  agents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  website?: Maybe<Scalars['String']>;
};

export type Agent = {
  __typename?: 'Agent';
  agency?: Maybe<Agency>;
  agent_number?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<UploadFile>;
  properties?: Maybe<Array<Maybe<Property>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Enum_Agent_Status>;
  updated_at: Scalars['DateTime'];
  user?: Maybe<UsersPermissionsUser>;
  verified?: Maybe<Scalars['Boolean']>;
};


export type AgentPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type AgentAggregator = {
  __typename?: 'AgentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AgentConnection = {
  __typename?: 'AgentConnection';
  aggregate?: Maybe<AgentAggregator>;
  groupBy?: Maybe<AgentGroupBy>;
  values?: Maybe<Array<Maybe<Agent>>>;
};

export type AgentConnectionAgency = {
  __typename?: 'AgentConnectionAgency';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AgentConnectionAgent_Number = {
  __typename?: 'AgentConnectionAgent_number';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgentConnectionCreated_At = {
  __typename?: 'AgentConnectionCreated_at';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AgentConnectionEmail = {
  __typename?: 'AgentConnectionEmail';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgentConnectionId = {
  __typename?: 'AgentConnectionId';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AgentConnectionName = {
  __typename?: 'AgentConnectionName';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgentConnectionPhone_Number = {
  __typename?: 'AgentConnectionPhone_number';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgentConnectionPhoto = {
  __typename?: 'AgentConnectionPhoto';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AgentConnectionPublished_At = {
  __typename?: 'AgentConnectionPublished_at';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AgentConnectionStatus = {
  __typename?: 'AgentConnectionStatus';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['String']>;
};

export type AgentConnectionUpdated_At = {
  __typename?: 'AgentConnectionUpdated_at';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type AgentConnectionUser = {
  __typename?: 'AgentConnectionUser';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type AgentConnectionVerified = {
  __typename?: 'AgentConnectionVerified';
  connection?: Maybe<AgentConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type AgentGroupBy = {
  __typename?: 'AgentGroupBy';
  agency?: Maybe<Array<Maybe<AgentConnectionAgency>>>;
  agent_number?: Maybe<Array<Maybe<AgentConnectionAgent_Number>>>;
  created_at?: Maybe<Array<Maybe<AgentConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<AgentConnectionEmail>>>;
  id?: Maybe<Array<Maybe<AgentConnectionId>>>;
  name?: Maybe<Array<Maybe<AgentConnectionName>>>;
  phone_number?: Maybe<Array<Maybe<AgentConnectionPhone_Number>>>;
  photo?: Maybe<Array<Maybe<AgentConnectionPhoto>>>;
  published_at?: Maybe<Array<Maybe<AgentConnectionPublished_At>>>;
  status?: Maybe<Array<Maybe<AgentConnectionStatus>>>;
  updated_at?: Maybe<Array<Maybe<AgentConnectionUpdated_At>>>;
  user?: Maybe<Array<Maybe<AgentConnectionUser>>>;
  verified?: Maybe<Array<Maybe<AgentConnectionVerified>>>;
};

export type AgentInput = {
  agency?: Maybe<Scalars['ID']>;
  agent_number?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['ID']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Enum_Agent_Status>;
  updated_by?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type City = {
  __typename?: 'City';
  created_at: Scalars['DateTime'];
  district?: Maybe<District>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Province>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  suburbs?: Maybe<Array<Maybe<Suburb>>>;
  updated_at: Scalars['DateTime'];
};


export type CitySuburbsArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CityAggregator = {
  __typename?: 'CityAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CityConnection = {
  __typename?: 'CityConnection';
  aggregate?: Maybe<CityAggregator>;
  groupBy?: Maybe<CityGroupBy>;
  values?: Maybe<Array<Maybe<City>>>;
};

export type CityConnectionCreated_At = {
  __typename?: 'CityConnectionCreated_at';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CityConnectionDistrict = {
  __typename?: 'CityConnectionDistrict';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CityConnectionId = {
  __typename?: 'CityConnectionId';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CityConnectionName = {
  __typename?: 'CityConnectionName';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CityConnectionProvince = {
  __typename?: 'CityConnectionProvince';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CityConnectionPublished_At = {
  __typename?: 'CityConnectionPublished_at';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CityConnectionSlug = {
  __typename?: 'CityConnectionSlug';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CityConnectionUpdated_At = {
  __typename?: 'CityConnectionUpdated_at';
  connection?: Maybe<CityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CityGroupBy = {
  __typename?: 'CityGroupBy';
  created_at?: Maybe<Array<Maybe<CityConnectionCreated_At>>>;
  district?: Maybe<Array<Maybe<CityConnectionDistrict>>>;
  id?: Maybe<Array<Maybe<CityConnectionId>>>;
  name?: Maybe<Array<Maybe<CityConnectionName>>>;
  province?: Maybe<Array<Maybe<CityConnectionProvince>>>;
  published_at?: Maybe<Array<Maybe<CityConnectionPublished_At>>>;
  slug?: Maybe<Array<Maybe<CityConnectionSlug>>>;
  updated_at?: Maybe<Array<Maybe<CityConnectionUpdated_At>>>;
};

export type CityInput = {
  created_by?: Maybe<Scalars['ID']>;
  district?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  suburbs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  currency_symbol?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  provinces?: Maybe<Array<Maybe<Province>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};


export type CountryProvincesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type CountryAggregator = {
  __typename?: 'CountryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  aggregate?: Maybe<CountryAggregator>;
  groupBy?: Maybe<CountryGroupBy>;
  values?: Maybe<Array<Maybe<Country>>>;
};

export type CountryConnectionCode = {
  __typename?: 'CountryConnectionCode';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CountryConnectionCreated_At = {
  __typename?: 'CountryConnectionCreated_at';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CountryConnectionCurrency = {
  __typename?: 'CountryConnectionCurrency';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CountryConnectionCurrency_Symbol = {
  __typename?: 'CountryConnectionCurrency_symbol';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CountryConnectionId = {
  __typename?: 'CountryConnectionId';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type CountryConnectionName = {
  __typename?: 'CountryConnectionName';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type CountryConnectionPublished_At = {
  __typename?: 'CountryConnectionPublished_at';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CountryConnectionUpdated_At = {
  __typename?: 'CountryConnectionUpdated_at';
  connection?: Maybe<CountryConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type CountryGroupBy = {
  __typename?: 'CountryGroupBy';
  code?: Maybe<Array<Maybe<CountryConnectionCode>>>;
  created_at?: Maybe<Array<Maybe<CountryConnectionCreated_At>>>;
  currency?: Maybe<Array<Maybe<CountryConnectionCurrency>>>;
  currency_symbol?: Maybe<Array<Maybe<CountryConnectionCurrency_Symbol>>>;
  id?: Maybe<Array<Maybe<CountryConnectionId>>>;
  name?: Maybe<Array<Maybe<CountryConnectionName>>>;
  published_at?: Maybe<Array<Maybe<CountryConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<CountryConnectionUpdated_At>>>;
};

export type CountryInput = {
  code?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  currency_symbol?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provinces?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type District = {
  __typename?: 'District';
  cities?: Maybe<Array<Maybe<City>>>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Province>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type DistrictCitiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type DistrictAggregator = {
  __typename?: 'DistrictAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DistrictConnection = {
  __typename?: 'DistrictConnection';
  aggregate?: Maybe<DistrictAggregator>;
  groupBy?: Maybe<DistrictGroupBy>;
  values?: Maybe<Array<Maybe<District>>>;
};

export type DistrictConnectionCreated_At = {
  __typename?: 'DistrictConnectionCreated_at';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type DistrictConnectionId = {
  __typename?: 'DistrictConnectionId';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type DistrictConnectionName = {
  __typename?: 'DistrictConnectionName';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['String']>;
};

export type DistrictConnectionProvince = {
  __typename?: 'DistrictConnectionProvince';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type DistrictConnectionPublished_At = {
  __typename?: 'DistrictConnectionPublished_at';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type DistrictConnectionSlug = {
  __typename?: 'DistrictConnectionSlug';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['String']>;
};

export type DistrictConnectionUpdated_At = {
  __typename?: 'DistrictConnectionUpdated_at';
  connection?: Maybe<DistrictConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type DistrictGroupBy = {
  __typename?: 'DistrictGroupBy';
  created_at?: Maybe<Array<Maybe<DistrictConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<DistrictConnectionId>>>;
  name?: Maybe<Array<Maybe<DistrictConnectionName>>>;
  province?: Maybe<Array<Maybe<DistrictConnectionProvince>>>;
  published_at?: Maybe<Array<Maybe<DistrictConnectionPublished_At>>>;
  slug?: Maybe<Array<Maybe<DistrictConnectionSlug>>>;
  updated_at?: Maybe<Array<Maybe<DistrictConnectionUpdated_At>>>;
};

export type DistrictInput = {
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum Enum_Agent_Status {
  Active = 'active',
  Archived = 'archived',
  Inactive = 'inactive'
}

export enum Enum_Interestcase_Case_Status {
  Aborded = 'aborded',
  Completed = 'completed',
  InProgress = 'in_progress'
}

export enum Enum_Propertycategory_Type {
  Development = 'development',
  Hotel = 'hotel',
  Rent = 'rent',
  Sale = 'sale'
}

export enum Enum_Property_Publish_State {
  Active = 'active',
  Inactive = 'inactive',
  UnderReview = 'under_review'
}

export type EmailNotificationSubscription = {
  __typename?: 'EmailNotificationSubscription';
  country?: Maybe<Country>;
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};

export type EmailNotificationSubscriptionAggregator = {
  __typename?: 'EmailNotificationSubscriptionAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EmailNotificationSubscriptionConnection = {
  __typename?: 'EmailNotificationSubscriptionConnection';
  aggregate?: Maybe<EmailNotificationSubscriptionAggregator>;
  groupBy?: Maybe<EmailNotificationSubscriptionGroupBy>;
  values?: Maybe<Array<Maybe<EmailNotificationSubscription>>>;
};

export type EmailNotificationSubscriptionConnectionCountry = {
  __typename?: 'EmailNotificationSubscriptionConnectionCountry';
  connection?: Maybe<EmailNotificationSubscriptionConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type EmailNotificationSubscriptionConnectionCreated_At = {
  __typename?: 'EmailNotificationSubscriptionConnectionCreated_at';
  connection?: Maybe<EmailNotificationSubscriptionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type EmailNotificationSubscriptionConnectionEmail = {
  __typename?: 'EmailNotificationSubscriptionConnectionEmail';
  connection?: Maybe<EmailNotificationSubscriptionConnection>;
  key?: Maybe<Scalars['String']>;
};

export type EmailNotificationSubscriptionConnectionId = {
  __typename?: 'EmailNotificationSubscriptionConnectionId';
  connection?: Maybe<EmailNotificationSubscriptionConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type EmailNotificationSubscriptionConnectionPublished_At = {
  __typename?: 'EmailNotificationSubscriptionConnectionPublished_at';
  connection?: Maybe<EmailNotificationSubscriptionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type EmailNotificationSubscriptionConnectionUpdated_At = {
  __typename?: 'EmailNotificationSubscriptionConnectionUpdated_at';
  connection?: Maybe<EmailNotificationSubscriptionConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type EmailNotificationSubscriptionGroupBy = {
  __typename?: 'EmailNotificationSubscriptionGroupBy';
  country?: Maybe<Array<Maybe<EmailNotificationSubscriptionConnectionCountry>>>;
  created_at?: Maybe<Array<Maybe<EmailNotificationSubscriptionConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<EmailNotificationSubscriptionConnectionEmail>>>;
  id?: Maybe<Array<Maybe<EmailNotificationSubscriptionConnectionId>>>;
  published_at?: Maybe<Array<Maybe<EmailNotificationSubscriptionConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<EmailNotificationSubscriptionConnectionUpdated_At>>>;
};

export type EmailNotificationSubscriptionInput = {
  country?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FileInfoInput = {
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FileInput = {
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  size: Scalars['Float'];
  updated_by?: Maybe<Scalars['ID']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type InterestCase = {
  __typename?: 'InterestCase';
  caseID?: Maybe<Scalars['String']>;
  case_status?: Maybe<Enum_Interestcase_Case_Status>;
  cell_number?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  property?: Maybe<Property>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
  users_permissions_user?: Maybe<UsersPermissionsUser>;
};

export type InterestCaseAggregator = {
  __typename?: 'InterestCaseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type InterestCaseConnection = {
  __typename?: 'InterestCaseConnection';
  aggregate?: Maybe<InterestCaseAggregator>;
  groupBy?: Maybe<InterestCaseGroupBy>;
  values?: Maybe<Array<Maybe<InterestCase>>>;
};

export type InterestCaseConnectionCaseId = {
  __typename?: 'InterestCaseConnectionCaseID';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InterestCaseConnectionCase_Status = {
  __typename?: 'InterestCaseConnectionCase_status';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InterestCaseConnectionCell_Number = {
  __typename?: 'InterestCaseConnectionCell_number';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InterestCaseConnectionCreated_At = {
  __typename?: 'InterestCaseConnectionCreated_at';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InterestCaseConnectionEmail = {
  __typename?: 'InterestCaseConnectionEmail';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InterestCaseConnectionFull_Name = {
  __typename?: 'InterestCaseConnectionFull_name';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InterestCaseConnectionId = {
  __typename?: 'InterestCaseConnectionId';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InterestCaseConnectionMessage = {
  __typename?: 'InterestCaseConnectionMessage';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type InterestCaseConnectionProperty = {
  __typename?: 'InterestCaseConnectionProperty';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InterestCaseConnectionPublished_At = {
  __typename?: 'InterestCaseConnectionPublished_at';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InterestCaseConnectionUpdated_At = {
  __typename?: 'InterestCaseConnectionUpdated_at';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type InterestCaseConnectionUsers_Permissions_User = {
  __typename?: 'InterestCaseConnectionUsers_permissions_user';
  connection?: Maybe<InterestCaseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type InterestCaseGroupBy = {
  __typename?: 'InterestCaseGroupBy';
  caseID?: Maybe<Array<Maybe<InterestCaseConnectionCaseId>>>;
  case_status?: Maybe<Array<Maybe<InterestCaseConnectionCase_Status>>>;
  cell_number?: Maybe<Array<Maybe<InterestCaseConnectionCell_Number>>>;
  created_at?: Maybe<Array<Maybe<InterestCaseConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<InterestCaseConnectionEmail>>>;
  full_name?: Maybe<Array<Maybe<InterestCaseConnectionFull_Name>>>;
  id?: Maybe<Array<Maybe<InterestCaseConnectionId>>>;
  message?: Maybe<Array<Maybe<InterestCaseConnectionMessage>>>;
  property?: Maybe<Array<Maybe<InterestCaseConnectionProperty>>>;
  published_at?: Maybe<Array<Maybe<InterestCaseConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<InterestCaseConnectionUpdated_At>>>;
  users_permissions_user?: Maybe<Array<Maybe<InterestCaseConnectionUsers_Permissions_User>>>;
};

export type InterestCaseInput = {
  caseID?: Maybe<Scalars['String']>;
  case_status?: Maybe<Enum_Interestcase_Case_Status>;
  cell_number?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
};

export type LocationDataInput = {
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  ip?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type Morph = Agency | AgencyAggregator | AgencyConnection | AgencyConnectionAddress | AgencyConnectionCreated_At | AgencyConnectionDescription | AgencyConnectionEmail | AgencyConnectionId | AgencyConnectionLogo | AgencyConnectionName | AgencyConnectionPhone_Number | AgencyConnectionPublished_At | AgencyConnectionUpdated_At | AgencyConnectionWebsite | AgencyGroupBy | Agent | AgentAggregator | AgentConnection | AgentConnectionAgency | AgentConnectionAgent_Number | AgentConnectionCreated_At | AgentConnectionEmail | AgentConnectionId | AgentConnectionName | AgentConnectionPhone_Number | AgentConnectionPhoto | AgentConnectionPublished_At | AgentConnectionStatus | AgentConnectionUpdated_At | AgentConnectionUser | AgentConnectionVerified | AgentGroupBy | City | CityAggregator | CityConnection | CityConnectionCreated_At | CityConnectionDistrict | CityConnectionId | CityConnectionName | CityConnectionProvince | CityConnectionPublished_At | CityConnectionSlug | CityConnectionUpdated_At | CityGroupBy | Country | CountryAggregator | CountryConnection | CountryConnectionCode | CountryConnectionCreated_At | CountryConnectionCurrency | CountryConnectionCurrency_Symbol | CountryConnectionId | CountryConnectionName | CountryConnectionPublished_At | CountryConnectionUpdated_At | CountryGroupBy | District | DistrictAggregator | DistrictConnection | DistrictConnectionCreated_At | DistrictConnectionId | DistrictConnectionName | DistrictConnectionProvince | DistrictConnectionPublished_At | DistrictConnectionSlug | DistrictConnectionUpdated_At | DistrictGroupBy | EmailNotificationSubscription | EmailNotificationSubscriptionAggregator | EmailNotificationSubscriptionConnection | EmailNotificationSubscriptionConnectionCountry | EmailNotificationSubscriptionConnectionCreated_At | EmailNotificationSubscriptionConnectionEmail | EmailNotificationSubscriptionConnectionId | EmailNotificationSubscriptionConnectionPublished_At | EmailNotificationSubscriptionConnectionUpdated_At | EmailNotificationSubscriptionGroupBy | InterestCase | InterestCaseAggregator | InterestCaseConnection | InterestCaseConnectionCaseId | InterestCaseConnectionCase_Status | InterestCaseConnectionCell_Number | InterestCaseConnectionCreated_At | InterestCaseConnectionEmail | InterestCaseConnectionFull_Name | InterestCaseConnectionId | InterestCaseConnectionMessage | InterestCaseConnectionProperty | InterestCaseConnectionPublished_At | InterestCaseConnectionUpdated_At | InterestCaseConnectionUsers_Permissions_User | InterestCaseGroupBy | Notification | NotificationAggregator | NotificationConnection | NotificationConnectionCreated_At | NotificationConnectionId | NotificationConnectionPublished_At | NotificationConnectionUpdated_At | NotificationConnectionUsers_Permissions_User | NotificationGroupBy | Property | PropertyAggregator | PropertyAggregatorAvg | PropertyAggregatorMax | PropertyAggregatorMin | PropertyAggregatorSum | PropertyAvailability | PropertyAvailabilityAggregator | PropertyAvailabilityConnection | PropertyAvailabilityConnectionCreated_At | PropertyAvailabilityConnectionId | PropertyAvailabilityConnectionName_En | PropertyAvailabilityConnectionName_Fr | PropertyAvailabilityConnectionPublished_At | PropertyAvailabilityConnectionUpdated_At | PropertyAvailabilityGroupBy | PropertyCategory | PropertyCategoryAggregator | PropertyCategoryConnection | PropertyCategoryConnectionCreated_At | PropertyCategoryConnectionHeading | PropertyCategoryConnectionIcon_Index | PropertyCategoryConnectionId | PropertyCategoryConnectionName | PropertyCategoryConnectionPublished_At | PropertyCategoryConnectionSlug | PropertyCategoryConnectionType | PropertyCategoryConnectionUpdated_At | PropertyCategoryGroupBy | PropertyConnection | PropertyConnectionAgent | PropertyConnectionBathrooms | PropertyConnectionBedrooms | PropertyConnectionCreated_At | PropertyConnectionDescription | PropertyConnectionDining_Rooms | PropertyConnectionFloor_Size | PropertyConnectionFurnished | PropertyConnectionId | PropertyConnectionKitchens | PropertyConnectionLease_Period | PropertyConnectionLifestyle | PropertyConnectionLounges | PropertyConnectionOccupation_Date | PropertyConnectionParking | PropertyConnectionPool | PropertyConnectionPrice | PropertyConnectionProperty_Availability | PropertyConnectionProperty_Category | PropertyConnectionPublish_State | PropertyConnectionPublished_At | PropertyConnectionReference_Number | PropertyConnectionRental_Term | PropertyConnectionSlug | PropertyConnectionStreet_Address | PropertyConnectionSuburb | PropertyConnectionType_Of_Property | PropertyConnectionUpdated_At | PropertyGroupBy | PropertyStatus | PropertyStatusAggregator | PropertyStatusConnection | PropertyStatusConnectionCreated_At | PropertyStatusConnectionId | PropertyStatusConnectionPublished_At | PropertyStatusConnectionStatus_En | PropertyStatusConnectionStatus_Fr | PropertyStatusConnectionUpdated_At | PropertyStatusGroupBy | Province | ProvinceAggregator | ProvinceConnection | ProvinceConnectionCountry | ProvinceConnectionCreated_At | ProvinceConnectionId | ProvinceConnectionName | ProvinceConnectionPublished_At | ProvinceConnectionSlug | ProvinceConnectionUpdated_At | ProvinceGroupBy | RentalTerm | RentalTermAggregator | RentalTermConnection | RentalTermConnectionCreated_At | RentalTermConnectionId | RentalTermConnectionName_En | RentalTermConnectionName_Fr | RentalTermConnectionPublished_At | RentalTermConnectionUpdated_At | RentalTermGroupBy | SearchPayload | SellInterestCase | SellInterestCaseAggregator | SellInterestCaseConnection | SellInterestCaseConnectionCase_Number | SellInterestCaseConnectionCreated_At | SellInterestCaseConnectionEmail | SellInterestCaseConnectionFull_Name | SellInterestCaseConnectionId | SellInterestCaseConnectionMessage | SellInterestCaseConnectionPhone_Number | SellInterestCaseConnectionPublished_At | SellInterestCaseConnectionUpdated_At | SellInterestCaseConnectionUsers_Permissions_User | SellInterestCaseGroupBy | Suburb | SuburbAggregator | SuburbConnection | SuburbConnectionCity | SuburbConnectionCreated_At | SuburbConnectionId | SuburbConnectionName | SuburbConnectionPostal_Code | SuburbConnectionPublished_At | SuburbConnectionSlug | SuburbConnectionUpdated_At | SuburbGroupBy | Team | TeamAggregator | TeamConnection | TeamConnectionCreated_At | TeamConnectionId | TeamConnectionLinkedin_Link | TeamConnectionName | TeamConnectionPhoto | TeamConnectionPublished_At | TeamConnectionRole | TeamConnectionRole_Description | TeamConnectionTwitter_Link | TeamConnectionUpdated_At | TeamGroupBy | TypeOfProperty | TypeOfPropertyAggregator | TypeOfPropertyConnection | TypeOfPropertyConnectionCreated_At | TypeOfPropertyConnectionId | TypeOfPropertyConnectionName_En | TypeOfPropertyConnectionName_Fr | TypeOfPropertyConnectionPublished_At | TypeOfPropertyConnectionUpdated_At | TypeOfPropertyGroupBy | UploadFile | UploadFileAggregator | UploadFileAggregatorAvg | UploadFileAggregatorMax | UploadFileAggregatorMin | UploadFileAggregatorSum | UploadFileConnection | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionCreated_At | UploadFileConnectionExt | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionHeight | UploadFileConnectionId | UploadFileConnectionMime | UploadFileConnectionName | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionSize | UploadFileConnectionUpdated_At | UploadFileConnectionUrl | UploadFileConnectionWidth | UploadFileGroupBy | UserPermissionsPasswordPayload | UsersPermissionsLoginPayload | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleAggregator | UsersPermissionsRoleConnection | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionType | UsersPermissionsRoleGroupBy | UsersPermissionsUser | UsersPermissionsUserAggregator | UsersPermissionsUserConnection | UsersPermissionsUserConnectionAgent | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionFirstName | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionLastName | UsersPermissionsUserConnectionOnboarded | UsersPermissionsUserConnectionPhoneNumber | UsersPermissionsUserConnectionProfilePicture | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserGroupBy | CreateAgencyPayload | CreateAgentPayload | CreateCityPayload | CreateCountryPayload | CreateDistrictPayload | CreateEmailNotificationSubscriptionPayload | CreateInterestCasePayload | CreateNotificationPayload | CreatePropertyAvailabilityPayload | CreatePropertyCategoryPayload | CreatePropertyPayload | CreatePropertyStatusPayload | CreateProvincePayload | CreateRentalTermPayload | CreateRolePayload | CreateSellInterestCasePayload | CreateSuburbPayload | CreateTeamPayload | CreateTypeOfPropertyPayload | CreateUserPayload | DeleteAgencyPayload | DeleteAgentPayload | DeleteCityPayload | DeleteCountryPayload | DeleteDistrictPayload | DeleteEmailNotificationSubscriptionPayload | DeleteFilePayload | DeleteInterestCasePayload | DeleteNotificationPayload | DeletePropertyAvailabilityPayload | DeletePropertyCategoryPayload | DeletePropertyPayload | DeletePropertyStatusPayload | DeleteProvincePayload | DeleteRentalTermPayload | DeleteRolePayload | DeleteSellInterestCasePayload | DeleteSuburbPayload | DeleteTeamPayload | DeleteTypeOfPropertyPayload | DeleteUserPayload | UpdateAgencyPayload | UpdateAgentPayload | UpdateCityPayload | UpdateCountryPayload | UpdateDistrictPayload | UpdateEmailNotificationSubscriptionPayload | UpdateInterestCasePayload | UpdateNotificationPayload | UpdatePropertyAvailabilityPayload | UpdatePropertyCategoryPayload | UpdatePropertyPayload | UpdatePropertyStatusPayload | UpdateProvincePayload | UpdateRentalTermPayload | UpdateRolePayload | UpdateSellInterestCasePayload | UpdateSuburbPayload | UpdateTeamPayload | UpdateTypeOfPropertyPayload | UpdateUserPayload;

export type Mutation = {
  __typename?: 'Mutation';
  addAgentProperty?: Maybe<Property>;
  archiveAgencyAgent?: Maybe<Agent>;
  changePropertyAgents?: Maybe<Property>;
  createAgency?: Maybe<CreateAgencyPayload>;
  createAgencyAgent?: Maybe<Agent>;
  createAgent?: Maybe<CreateAgentPayload>;
  createAgentUser?: Maybe<Agent>;
  createCity?: Maybe<CreateCityPayload>;
  createCountry?: Maybe<CreateCountryPayload>;
  createDistrict?: Maybe<CreateDistrictPayload>;
  createEmailNotificationSubscription?: Maybe<CreateEmailNotificationSubscriptionPayload>;
  createInterestCase?: Maybe<CreateInterestCasePayload>;
  createNotification?: Maybe<CreateNotificationPayload>;
  createProperty?: Maybe<CreatePropertyPayload>;
  createPropertyAvailability?: Maybe<CreatePropertyAvailabilityPayload>;
  createPropertyCategory?: Maybe<CreatePropertyCategoryPayload>;
  createPropertyStatus?: Maybe<CreatePropertyStatusPayload>;
  createProvince?: Maybe<CreateProvincePayload>;
  createRentalTerm?: Maybe<CreateRentalTermPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  createSellInterestCase?: Maybe<CreateSellInterestCasePayload>;
  createSubscription?: Maybe<EmailNotificationSubscription>;
  createSuburb?: Maybe<CreateSuburbPayload>;
  createTeam?: Maybe<CreateTeamPayload>;
  createTypeOfProperty?: Maybe<CreateTypeOfPropertyPayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  deleteAgency?: Maybe<DeleteAgencyPayload>;
  deleteAgent?: Maybe<DeleteAgentPayload>;
  deleteCity?: Maybe<DeleteCityPayload>;
  deleteCountry?: Maybe<DeleteCountryPayload>;
  deleteDistrict?: Maybe<DeleteDistrictPayload>;
  deleteEmailNotificationSubscription?: Maybe<DeleteEmailNotificationSubscriptionPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  deleteInterestCase?: Maybe<DeleteInterestCasePayload>;
  deleteNotification?: Maybe<DeleteNotificationPayload>;
  deleteProperty?: Maybe<DeletePropertyPayload>;
  deletePropertyAvailability?: Maybe<DeletePropertyAvailabilityPayload>;
  deletePropertyCategory?: Maybe<DeletePropertyCategoryPayload>;
  deletePropertyStatus?: Maybe<DeletePropertyStatusPayload>;
  deleteProvince?: Maybe<DeleteProvincePayload>;
  deleteRentalTerm?: Maybe<DeleteRentalTermPayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteSellInterestCase?: Maybe<DeleteSellInterestCasePayload>;
  deleteSuburb?: Maybe<DeleteSuburbPayload>;
  deleteTeam?: Maybe<DeleteTeamPayload>;
  deleteTypeOfProperty?: Maybe<DeleteTypeOfPropertyPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFile>>;
  publishAgentProperty?: Maybe<Property>;
  register: UsersPermissionsLoginPayload;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  unArchiveAgencyAgent?: Maybe<Agent>;
  unPublishAgentProperty?: Maybe<Property>;
  updateAdminAgency?: Maybe<Agency>;
  updateAgency?: Maybe<UpdateAgencyPayload>;
  updateAgencyAgent?: Maybe<Agent>;
  updateAgent?: Maybe<UpdateAgentPayload>;
  updateAgentProperty?: Maybe<Property>;
  updateCity?: Maybe<UpdateCityPayload>;
  updateCountry?: Maybe<UpdateCountryPayload>;
  updateDistrict?: Maybe<UpdateDistrictPayload>;
  updateEmailNotificationSubscription?: Maybe<UpdateEmailNotificationSubscriptionPayload>;
  updateFileInfo: UploadFile;
  updateInterestCase?: Maybe<UpdateInterestCasePayload>;
  updateMyUser?: Maybe<UsersPermissionsUser>;
  updateNotification?: Maybe<UpdateNotificationPayload>;
  updateProperty?: Maybe<UpdatePropertyPayload>;
  updatePropertyAvailability?: Maybe<UpdatePropertyAvailabilityPayload>;
  updatePropertyCategory?: Maybe<UpdatePropertyCategoryPayload>;
  updatePropertyStatus?: Maybe<UpdatePropertyStatusPayload>;
  updateProvince?: Maybe<UpdateProvincePayload>;
  updateRentalTerm?: Maybe<UpdateRentalTermPayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  updateSellInterestCase?: Maybe<UpdateSellInterestCasePayload>;
  updateSuburb?: Maybe<UpdateSuburbPayload>;
  updateTeam?: Maybe<UpdateTeamPayload>;
  updateTypeOfProperty?: Maybe<UpdateTypeOfPropertyPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  upload: UploadFile;
};


export type MutationAddAgentPropertyArgs = {
  input?: Maybe<CreatePropertyInput>;
};


export type MutationArchiveAgencyAgentArgs = {
  id: Scalars['ID'];
};


export type MutationChangePropertyAgentsArgs = {
  agent: Scalars['ID'];
  property: Scalars['ID'];
};


export type MutationCreateAgencyArgs = {
  input?: Maybe<CreateAgencyInput>;
};


export type MutationCreateAgencyAgentArgs = {
  input: CreateAgencyAgentInput;
};


export type MutationCreateAgentArgs = {
  input?: Maybe<CreateAgentInput>;
};


export type MutationCreateAgentUserArgs = {
  input?: Maybe<CreateAgentUserInput>;
};


export type MutationCreateCityArgs = {
  input?: Maybe<CreateCityInput>;
};


export type MutationCreateCountryArgs = {
  input?: Maybe<CreateCountryInput>;
};


export type MutationCreateDistrictArgs = {
  input?: Maybe<CreateDistrictInput>;
};


export type MutationCreateEmailNotificationSubscriptionArgs = {
  input?: Maybe<CreateEmailNotificationSubscriptionInput>;
};


export type MutationCreateInterestCaseArgs = {
  input?: Maybe<CreateInterestCaseInput>;
};


export type MutationCreateNotificationArgs = {
  input?: Maybe<CreateNotificationInput>;
};


export type MutationCreatePropertyArgs = {
  input?: Maybe<CreatePropertyInput>;
};


export type MutationCreatePropertyAvailabilityArgs = {
  input?: Maybe<CreatePropertyAvailabilityInput>;
};


export type MutationCreatePropertyCategoryArgs = {
  input?: Maybe<CreatePropertyCategoryInput>;
};


export type MutationCreatePropertyStatusArgs = {
  input?: Maybe<CreatePropertyStatusInput>;
};


export type MutationCreateProvinceArgs = {
  input?: Maybe<CreateProvinceInput>;
};


export type MutationCreateRentalTermArgs = {
  input?: Maybe<CreateRentalTermInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationCreateSellInterestCaseArgs = {
  input?: Maybe<CreateSellInterestCaseInput>;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateSuburbArgs = {
  input?: Maybe<CreateSuburbInput>;
};


export type MutationCreateTeamArgs = {
  input?: Maybe<CreateTeamInput>;
};


export type MutationCreateTypeOfPropertyArgs = {
  input?: Maybe<CreateTypeOfPropertyInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationDeleteAgencyArgs = {
  input?: Maybe<DeleteAgencyInput>;
};


export type MutationDeleteAgentArgs = {
  input?: Maybe<DeleteAgentInput>;
};


export type MutationDeleteCityArgs = {
  input?: Maybe<DeleteCityInput>;
};


export type MutationDeleteCountryArgs = {
  input?: Maybe<DeleteCountryInput>;
};


export type MutationDeleteDistrictArgs = {
  input?: Maybe<DeleteDistrictInput>;
};


export type MutationDeleteEmailNotificationSubscriptionArgs = {
  input?: Maybe<DeleteEmailNotificationSubscriptionInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationDeleteInterestCaseArgs = {
  input?: Maybe<DeleteInterestCaseInput>;
};


export type MutationDeleteNotificationArgs = {
  input?: Maybe<DeleteNotificationInput>;
};


export type MutationDeletePropertyArgs = {
  input?: Maybe<DeletePropertyInput>;
};


export type MutationDeletePropertyAvailabilityArgs = {
  input?: Maybe<DeletePropertyAvailabilityInput>;
};


export type MutationDeletePropertyCategoryArgs = {
  input?: Maybe<DeletePropertyCategoryInput>;
};


export type MutationDeletePropertyStatusArgs = {
  input?: Maybe<DeletePropertyStatusInput>;
};


export type MutationDeleteProvinceArgs = {
  input?: Maybe<DeleteProvinceInput>;
};


export type MutationDeleteRentalTermArgs = {
  input?: Maybe<DeleteRentalTermInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationDeleteSellInterestCaseArgs = {
  input?: Maybe<DeleteSellInterestCaseInput>;
};


export type MutationDeleteSuburbArgs = {
  input?: Maybe<DeleteSuburbInput>;
};


export type MutationDeleteTeamArgs = {
  input?: Maybe<DeleteTeamInput>;
};


export type MutationDeleteTypeOfPropertyArgs = {
  input?: Maybe<DeleteTypeOfPropertyInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
  ref?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['ID']>;
  source?: Maybe<Scalars['String']>;
};


export type MutationPublishAgentPropertyArgs = {
  id: Scalars['ID'];
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationUnArchiveAgencyAgentArgs = {
  id: Scalars['ID'];
};


export type MutationUnPublishAgentPropertyArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateAdminAgencyArgs = {
  input: UpdateAdminAgencyInput;
};


export type MutationUpdateAgencyArgs = {
  input?: Maybe<UpdateAgencyInput>;
};


export type MutationUpdateAgencyAgentArgs = {
  input: UpdateAgencyAgentInput;
};


export type MutationUpdateAgentArgs = {
  input?: Maybe<UpdateAgentInput>;
};


export type MutationUpdateAgentPropertyArgs = {
  input?: Maybe<UpdateAgentPropertyInput>;
};


export type MutationUpdateCityArgs = {
  input?: Maybe<UpdateCityInput>;
};


export type MutationUpdateCountryArgs = {
  input?: Maybe<UpdateCountryInput>;
};


export type MutationUpdateDistrictArgs = {
  input?: Maybe<UpdateDistrictInput>;
};


export type MutationUpdateEmailNotificationSubscriptionArgs = {
  input?: Maybe<UpdateEmailNotificationSubscriptionInput>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationUpdateInterestCaseArgs = {
  input?: Maybe<UpdateInterestCaseInput>;
};


export type MutationUpdateMyUserArgs = {
  input?: Maybe<UpdateMyUserInput>;
};


export type MutationUpdateNotificationArgs = {
  input?: Maybe<UpdateNotificationInput>;
};


export type MutationUpdatePropertyArgs = {
  input?: Maybe<UpdatePropertyInput>;
};


export type MutationUpdatePropertyAvailabilityArgs = {
  input?: Maybe<UpdatePropertyAvailabilityInput>;
};


export type MutationUpdatePropertyCategoryArgs = {
  input?: Maybe<UpdatePropertyCategoryInput>;
};


export type MutationUpdatePropertyStatusArgs = {
  input?: Maybe<UpdatePropertyStatusInput>;
};


export type MutationUpdateProvinceArgs = {
  input?: Maybe<UpdateProvinceInput>;
};


export type MutationUpdateRentalTermArgs = {
  input?: Maybe<UpdateRentalTermInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationUpdateSellInterestCaseArgs = {
  input?: Maybe<UpdateSellInterestCaseInput>;
};


export type MutationUpdateSuburbArgs = {
  input?: Maybe<UpdateSuburbInput>;
};


export type MutationUpdateTeamArgs = {
  input?: Maybe<UpdateTeamInput>;
};


export type MutationUpdateTypeOfPropertyArgs = {
  input?: Maybe<UpdateTypeOfPropertyInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationUploadArgs = {
  field?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: Maybe<FileInfoInput>;
  ref?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['ID']>;
  source?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
  users_permissions_user?: Maybe<UsersPermissionsUser>;
};

export type NotificationAggregator = {
  __typename?: 'NotificationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  aggregate?: Maybe<NotificationAggregator>;
  groupBy?: Maybe<NotificationGroupBy>;
  values?: Maybe<Array<Maybe<Notification>>>;
};

export type NotificationConnectionCreated_At = {
  __typename?: 'NotificationConnectionCreated_at';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type NotificationConnectionId = {
  __typename?: 'NotificationConnectionId';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type NotificationConnectionPublished_At = {
  __typename?: 'NotificationConnectionPublished_at';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type NotificationConnectionUpdated_At = {
  __typename?: 'NotificationConnectionUpdated_at';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type NotificationConnectionUsers_Permissions_User = {
  __typename?: 'NotificationConnectionUsers_permissions_user';
  connection?: Maybe<NotificationConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type NotificationGroupBy = {
  __typename?: 'NotificationGroupBy';
  created_at?: Maybe<Array<Maybe<NotificationConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<NotificationConnectionId>>>;
  published_at?: Maybe<Array<Maybe<NotificationConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<NotificationConnectionUpdated_At>>>;
  users_permissions_user?: Maybe<Array<Maybe<NotificationConnectionUsers_Permissions_User>>>;
};

export type NotificationInput = {
  created_by?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
};

export type PermissionInput = {
  action: Scalars['String'];
  controller: Scalars['String'];
  created_by?: Maybe<Scalars['ID']>;
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['ID']>;
  type: Scalars['String'];
  updated_by?: Maybe<Scalars['ID']>;
};

export type Property = {
  __typename?: 'Property';
  agent?: Maybe<Agent>;
  bathrooms?: Maybe<Scalars['Long']>;
  bedrooms?: Maybe<Scalars['Long']>;
  created_at: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dining_rooms?: Maybe<Scalars['Long']>;
  floor_size?: Maybe<Scalars['Long']>;
  furnished?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  interest_cases?: Maybe<Array<Maybe<InterestCase>>>;
  interested_users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  kitchens?: Maybe<Scalars['Long']>;
  lease_period?: Maybe<Scalars['String']>;
  lifestyle?: Maybe<Scalars['String']>;
  lounges?: Maybe<Scalars['Long']>;
  occupation_date: Scalars['Date'];
  parking?: Maybe<Scalars['Long']>;
  photos?: Maybe<Array<Maybe<UploadFile>>>;
  pool?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  property_availability?: Maybe<PropertyAvailability>;
  property_category?: Maybe<PropertyCategory>;
  publish_state?: Maybe<Enum_Property_Publish_State>;
  published_at?: Maybe<Scalars['DateTime']>;
  reference_number?: Maybe<Scalars['Long']>;
  rental_term?: Maybe<RentalTerm>;
  slug?: Maybe<Scalars['String']>;
  street_address: Scalars['String'];
  suburb?: Maybe<Suburb>;
  type_of_property?: Maybe<TypeOfProperty>;
  updated_at: Scalars['DateTime'];
};


export type PropertyInterest_CasesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PropertyInterested_UsersArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PropertyPhotosArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PropertyAggregator = {
  __typename?: 'PropertyAggregator';
  avg?: Maybe<PropertyAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<PropertyAggregatorMax>;
  min?: Maybe<PropertyAggregatorMin>;
  sum?: Maybe<PropertyAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PropertyAggregatorAvg = {
  __typename?: 'PropertyAggregatorAvg';
  price?: Maybe<Scalars['Float']>;
};

export type PropertyAggregatorMax = {
  __typename?: 'PropertyAggregatorMax';
  price?: Maybe<Scalars['Float']>;
};

export type PropertyAggregatorMin = {
  __typename?: 'PropertyAggregatorMin';
  price?: Maybe<Scalars['Float']>;
};

export type PropertyAggregatorSum = {
  __typename?: 'PropertyAggregatorSum';
  price?: Maybe<Scalars['Float']>;
};

export type PropertyAvailability = {
  __typename?: 'PropertyAvailability';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name_en?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};


export type PropertyAvailabilityPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PropertyAvailabilityAggregator = {
  __typename?: 'PropertyAvailabilityAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PropertyAvailabilityConnection = {
  __typename?: 'PropertyAvailabilityConnection';
  aggregate?: Maybe<PropertyAvailabilityAggregator>;
  groupBy?: Maybe<PropertyAvailabilityGroupBy>;
  values?: Maybe<Array<Maybe<PropertyAvailability>>>;
};

export type PropertyAvailabilityConnectionCreated_At = {
  __typename?: 'PropertyAvailabilityConnectionCreated_at';
  connection?: Maybe<PropertyAvailabilityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyAvailabilityConnectionId = {
  __typename?: 'PropertyAvailabilityConnectionId';
  connection?: Maybe<PropertyAvailabilityConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyAvailabilityConnectionName_En = {
  __typename?: 'PropertyAvailabilityConnectionName_en';
  connection?: Maybe<PropertyAvailabilityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyAvailabilityConnectionName_Fr = {
  __typename?: 'PropertyAvailabilityConnectionName_fr';
  connection?: Maybe<PropertyAvailabilityConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyAvailabilityConnectionPublished_At = {
  __typename?: 'PropertyAvailabilityConnectionPublished_at';
  connection?: Maybe<PropertyAvailabilityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyAvailabilityConnectionUpdated_At = {
  __typename?: 'PropertyAvailabilityConnectionUpdated_at';
  connection?: Maybe<PropertyAvailabilityConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyAvailabilityGroupBy = {
  __typename?: 'PropertyAvailabilityGroupBy';
  created_at?: Maybe<Array<Maybe<PropertyAvailabilityConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<PropertyAvailabilityConnectionId>>>;
  name_en?: Maybe<Array<Maybe<PropertyAvailabilityConnectionName_En>>>;
  name_fr?: Maybe<Array<Maybe<PropertyAvailabilityConnectionName_Fr>>>;
  published_at?: Maybe<Array<Maybe<PropertyAvailabilityConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<PropertyAvailabilityConnectionUpdated_At>>>;
};

export type PropertyAvailabilityInput = {
  created_by?: Maybe<Scalars['ID']>;
  name_en?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PropertyCategory = {
  __typename?: 'PropertyCategory';
  created_at: Scalars['DateTime'];
  heading?: Maybe<Scalars['String']>;
  icon_index?: Maybe<Scalars['Long']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  type: Enum_Propertycategory_Type;
  updated_at: Scalars['DateTime'];
};


export type PropertyCategoryPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PropertyCategoryAggregator = {
  __typename?: 'PropertyCategoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PropertyCategoryConnection = {
  __typename?: 'PropertyCategoryConnection';
  aggregate?: Maybe<PropertyCategoryAggregator>;
  groupBy?: Maybe<PropertyCategoryGroupBy>;
  values?: Maybe<Array<Maybe<PropertyCategory>>>;
};

export type PropertyCategoryConnectionCreated_At = {
  __typename?: 'PropertyCategoryConnectionCreated_at';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyCategoryConnectionHeading = {
  __typename?: 'PropertyCategoryConnectionHeading';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyCategoryConnectionIcon_Index = {
  __typename?: 'PropertyCategoryConnectionIcon_index';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyCategoryConnectionId = {
  __typename?: 'PropertyCategoryConnectionId';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyCategoryConnectionName = {
  __typename?: 'PropertyCategoryConnectionName';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyCategoryConnectionPublished_At = {
  __typename?: 'PropertyCategoryConnectionPublished_at';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyCategoryConnectionSlug = {
  __typename?: 'PropertyCategoryConnectionSlug';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyCategoryConnectionType = {
  __typename?: 'PropertyCategoryConnectionType';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyCategoryConnectionUpdated_At = {
  __typename?: 'PropertyCategoryConnectionUpdated_at';
  connection?: Maybe<PropertyCategoryConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyCategoryGroupBy = {
  __typename?: 'PropertyCategoryGroupBy';
  created_at?: Maybe<Array<Maybe<PropertyCategoryConnectionCreated_At>>>;
  heading?: Maybe<Array<Maybe<PropertyCategoryConnectionHeading>>>;
  icon_index?: Maybe<Array<Maybe<PropertyCategoryConnectionIcon_Index>>>;
  id?: Maybe<Array<Maybe<PropertyCategoryConnectionId>>>;
  name?: Maybe<Array<Maybe<PropertyCategoryConnectionName>>>;
  published_at?: Maybe<Array<Maybe<PropertyCategoryConnectionPublished_At>>>;
  slug?: Maybe<Array<Maybe<PropertyCategoryConnectionSlug>>>;
  type?: Maybe<Array<Maybe<PropertyCategoryConnectionType>>>;
  updated_at?: Maybe<Array<Maybe<PropertyCategoryConnectionUpdated_At>>>;
};

export type PropertyCategoryInput = {
  created_by?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  icon_index?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  type: Enum_Propertycategory_Type;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PropertyConnection = {
  __typename?: 'PropertyConnection';
  aggregate?: Maybe<PropertyAggregator>;
  groupBy?: Maybe<PropertyGroupBy>;
  values?: Maybe<Array<Maybe<Property>>>;
};

export type PropertyConnectionAgent = {
  __typename?: 'PropertyConnectionAgent';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionBathrooms = {
  __typename?: 'PropertyConnectionBathrooms';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionBedrooms = {
  __typename?: 'PropertyConnectionBedrooms';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionCreated_At = {
  __typename?: 'PropertyConnectionCreated_at';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyConnectionDescription = {
  __typename?: 'PropertyConnectionDescription';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyConnectionDining_Rooms = {
  __typename?: 'PropertyConnectionDining_rooms';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionFloor_Size = {
  __typename?: 'PropertyConnectionFloor_size';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionFurnished = {
  __typename?: 'PropertyConnectionFurnished';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type PropertyConnectionId = {
  __typename?: 'PropertyConnectionId';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionKitchens = {
  __typename?: 'PropertyConnectionKitchens';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionLease_Period = {
  __typename?: 'PropertyConnectionLease_period';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyConnectionLifestyle = {
  __typename?: 'PropertyConnectionLifestyle';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyConnectionLounges = {
  __typename?: 'PropertyConnectionLounges';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionOccupation_Date = {
  __typename?: 'PropertyConnectionOccupation_date';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionParking = {
  __typename?: 'PropertyConnectionParking';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionPool = {
  __typename?: 'PropertyConnectionPool';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type PropertyConnectionPrice = {
  __typename?: 'PropertyConnectionPrice';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type PropertyConnectionProperty_Availability = {
  __typename?: 'PropertyConnectionProperty_availability';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionProperty_Category = {
  __typename?: 'PropertyConnectionProperty_category';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionPublish_State = {
  __typename?: 'PropertyConnectionPublish_state';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyConnectionPublished_At = {
  __typename?: 'PropertyConnectionPublished_at';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyConnectionReference_Number = {
  __typename?: 'PropertyConnectionReference_number';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionRental_Term = {
  __typename?: 'PropertyConnectionRental_term';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionSlug = {
  __typename?: 'PropertyConnectionSlug';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyConnectionStreet_Address = {
  __typename?: 'PropertyConnectionStreet_address';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyConnectionSuburb = {
  __typename?: 'PropertyConnectionSuburb';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionType_Of_Property = {
  __typename?: 'PropertyConnectionType_of_property';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyConnectionUpdated_At = {
  __typename?: 'PropertyConnectionUpdated_at';
  connection?: Maybe<PropertyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyGroupBy = {
  __typename?: 'PropertyGroupBy';
  agent?: Maybe<Array<Maybe<PropertyConnectionAgent>>>;
  bathrooms?: Maybe<Array<Maybe<PropertyConnectionBathrooms>>>;
  bedrooms?: Maybe<Array<Maybe<PropertyConnectionBedrooms>>>;
  created_at?: Maybe<Array<Maybe<PropertyConnectionCreated_At>>>;
  description?: Maybe<Array<Maybe<PropertyConnectionDescription>>>;
  dining_rooms?: Maybe<Array<Maybe<PropertyConnectionDining_Rooms>>>;
  floor_size?: Maybe<Array<Maybe<PropertyConnectionFloor_Size>>>;
  furnished?: Maybe<Array<Maybe<PropertyConnectionFurnished>>>;
  id?: Maybe<Array<Maybe<PropertyConnectionId>>>;
  kitchens?: Maybe<Array<Maybe<PropertyConnectionKitchens>>>;
  lease_period?: Maybe<Array<Maybe<PropertyConnectionLease_Period>>>;
  lifestyle?: Maybe<Array<Maybe<PropertyConnectionLifestyle>>>;
  lounges?: Maybe<Array<Maybe<PropertyConnectionLounges>>>;
  occupation_date?: Maybe<Array<Maybe<PropertyConnectionOccupation_Date>>>;
  parking?: Maybe<Array<Maybe<PropertyConnectionParking>>>;
  pool?: Maybe<Array<Maybe<PropertyConnectionPool>>>;
  price?: Maybe<Array<Maybe<PropertyConnectionPrice>>>;
  property_availability?: Maybe<Array<Maybe<PropertyConnectionProperty_Availability>>>;
  property_category?: Maybe<Array<Maybe<PropertyConnectionProperty_Category>>>;
  publish_state?: Maybe<Array<Maybe<PropertyConnectionPublish_State>>>;
  published_at?: Maybe<Array<Maybe<PropertyConnectionPublished_At>>>;
  reference_number?: Maybe<Array<Maybe<PropertyConnectionReference_Number>>>;
  rental_term?: Maybe<Array<Maybe<PropertyConnectionRental_Term>>>;
  slug?: Maybe<Array<Maybe<PropertyConnectionSlug>>>;
  street_address?: Maybe<Array<Maybe<PropertyConnectionStreet_Address>>>;
  suburb?: Maybe<Array<Maybe<PropertyConnectionSuburb>>>;
  type_of_property?: Maybe<Array<Maybe<PropertyConnectionType_Of_Property>>>;
  updated_at?: Maybe<Array<Maybe<PropertyConnectionUpdated_At>>>;
};

export type PropertyInput = {
  agent?: Maybe<Scalars['ID']>;
  bathrooms?: Maybe<Scalars['Long']>;
  bedrooms?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  dining_rooms?: Maybe<Scalars['Long']>;
  floor_size?: Maybe<Scalars['Long']>;
  furnished?: Maybe<Scalars['Boolean']>;
  interest_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  interested_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  kitchens?: Maybe<Scalars['Long']>;
  lease_period?: Maybe<Scalars['String']>;
  lifestyle?: Maybe<Scalars['String']>;
  lounges?: Maybe<Scalars['Long']>;
  occupation_date: Scalars['Date'];
  parking?: Maybe<Scalars['Long']>;
  photos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pool?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  property_availability?: Maybe<Scalars['ID']>;
  property_category?: Maybe<Scalars['ID']>;
  publish_state?: Maybe<Enum_Property_Publish_State>;
  published_at?: Maybe<Scalars['DateTime']>;
  reference_number?: Maybe<Scalars['Long']>;
  rental_term?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  street_address: Scalars['String'];
  suburb?: Maybe<Scalars['ID']>;
  type_of_property?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type PropertyStatus = {
  __typename?: 'PropertyStatus';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  published_at?: Maybe<Scalars['DateTime']>;
  status_en?: Maybe<Scalars['String']>;
  status_fr?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type PropertyStatusAggregator = {
  __typename?: 'PropertyStatusAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PropertyStatusConnection = {
  __typename?: 'PropertyStatusConnection';
  aggregate?: Maybe<PropertyStatusAggregator>;
  groupBy?: Maybe<PropertyStatusGroupBy>;
  values?: Maybe<Array<Maybe<PropertyStatus>>>;
};

export type PropertyStatusConnectionCreated_At = {
  __typename?: 'PropertyStatusConnectionCreated_at';
  connection?: Maybe<PropertyStatusConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyStatusConnectionId = {
  __typename?: 'PropertyStatusConnectionId';
  connection?: Maybe<PropertyStatusConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type PropertyStatusConnectionPublished_At = {
  __typename?: 'PropertyStatusConnectionPublished_at';
  connection?: Maybe<PropertyStatusConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyStatusConnectionStatus_En = {
  __typename?: 'PropertyStatusConnectionStatus_en';
  connection?: Maybe<PropertyStatusConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyStatusConnectionStatus_Fr = {
  __typename?: 'PropertyStatusConnectionStatus_fr';
  connection?: Maybe<PropertyStatusConnection>;
  key?: Maybe<Scalars['String']>;
};

export type PropertyStatusConnectionUpdated_At = {
  __typename?: 'PropertyStatusConnectionUpdated_at';
  connection?: Maybe<PropertyStatusConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type PropertyStatusGroupBy = {
  __typename?: 'PropertyStatusGroupBy';
  created_at?: Maybe<Array<Maybe<PropertyStatusConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<PropertyStatusConnectionId>>>;
  published_at?: Maybe<Array<Maybe<PropertyStatusConnectionPublished_At>>>;
  status_en?: Maybe<Array<Maybe<PropertyStatusConnectionStatus_En>>>;
  status_fr?: Maybe<Array<Maybe<PropertyStatusConnectionStatus_Fr>>>;
  updated_at?: Maybe<Array<Maybe<PropertyStatusConnectionUpdated_At>>>;
};

export type PropertyStatusInput = {
  created_by?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  status_en?: Maybe<Scalars['String']>;
  status_fr?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Province = {
  __typename?: 'Province';
  cities?: Maybe<Array<Maybe<City>>>;
  country?: Maybe<Country>;
  created_at: Scalars['DateTime'];
  districts?: Maybe<Array<Maybe<District>>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type ProvinceCitiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ProvinceDistrictsArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type ProvinceAggregator = {
  __typename?: 'ProvinceAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProvinceConnection = {
  __typename?: 'ProvinceConnection';
  aggregate?: Maybe<ProvinceAggregator>;
  groupBy?: Maybe<ProvinceGroupBy>;
  values?: Maybe<Array<Maybe<Province>>>;
};

export type ProvinceConnectionCountry = {
  __typename?: 'ProvinceConnectionCountry';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ProvinceConnectionCreated_At = {
  __typename?: 'ProvinceConnectionCreated_at';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ProvinceConnectionId = {
  __typename?: 'ProvinceConnectionId';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type ProvinceConnectionName = {
  __typename?: 'ProvinceConnectionName';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ProvinceConnectionPublished_At = {
  __typename?: 'ProvinceConnectionPublished_at';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ProvinceConnectionSlug = {
  __typename?: 'ProvinceConnectionSlug';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['String']>;
};

export type ProvinceConnectionUpdated_At = {
  __typename?: 'ProvinceConnectionUpdated_at';
  connection?: Maybe<ProvinceConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type ProvinceGroupBy = {
  __typename?: 'ProvinceGroupBy';
  country?: Maybe<Array<Maybe<ProvinceConnectionCountry>>>;
  created_at?: Maybe<Array<Maybe<ProvinceConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<ProvinceConnectionId>>>;
  name?: Maybe<Array<Maybe<ProvinceConnectionName>>>;
  published_at?: Maybe<Array<Maybe<ProvinceConnectionPublished_At>>>;
  slug?: Maybe<Array<Maybe<ProvinceConnectionSlug>>>;
  updated_at?: Maybe<Array<Maybe<ProvinceConnectionUpdated_At>>>;
};

export type ProvinceInput = {
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  country?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  districts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  agencies?: Maybe<Array<Maybe<Agency>>>;
  agenciesConnection?: Maybe<AgencyConnection>;
  agency?: Maybe<Agency>;
  agent?: Maybe<Agent>;
  agents?: Maybe<Array<Maybe<Agent>>>;
  agentsConnection?: Maybe<AgentConnection>;
  cities?: Maybe<Array<Maybe<City>>>;
  citiesConnection?: Maybe<CityConnection>;
  city?: Maybe<City>;
  countAgentProperties?: Maybe<Scalars['Int']>;
  countProperties?: Maybe<Scalars['Int']>;
  countries?: Maybe<Array<Maybe<Country>>>;
  countriesConnection?: Maybe<CountryConnection>;
  country?: Maybe<Country>;
  district?: Maybe<District>;
  districts?: Maybe<Array<Maybe<District>>>;
  districtsConnection?: Maybe<DistrictConnection>;
  emailNotificationSubscription?: Maybe<EmailNotificationSubscription>;
  emailNotificationSubscriptions?: Maybe<Array<Maybe<EmailNotificationSubscription>>>;
  emailNotificationSubscriptionsConnection?: Maybe<EmailNotificationSubscriptionConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  findCityBySlug?: Maybe<City>;
  findDistrictBySlug?: Maybe<District>;
  findPropertCategoryBySlug?: Maybe<PropertyCategory>;
  findProvinceBySlug?: Maybe<Province>;
  findSuburbBySlug?: Maybe<Suburb>;
  getAgencyAgents?: Maybe<Array<Maybe<Agent>>>;
  getAgencyAgentsCount?: Maybe<Scalars['Int']>;
  getAgentProperties?: Maybe<Array<Maybe<Property>>>;
  getAgentProperty?: Maybe<Property>;
  getAgentPropertyInterestCases?: Maybe<Array<Maybe<InterestCase>>>;
  getAgentPropertyInterestCasesCount?: Maybe<Scalars['Int']>;
  getMyUser?: Maybe<UsersPermissionsUser>;
  interestCase?: Maybe<InterestCase>;
  interestCases?: Maybe<Array<Maybe<InterestCase>>>;
  interestCasesConnection?: Maybe<InterestCaseConnection>;
  me?: Maybe<UsersPermissionsMe>;
  notification?: Maybe<Notification>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  notificationsConnection?: Maybe<NotificationConnection>;
  properties?: Maybe<Array<Maybe<Property>>>;
  propertiesConnection?: Maybe<PropertyConnection>;
  property?: Maybe<Property>;
  propertyAvailabilities?: Maybe<Array<Maybe<PropertyAvailability>>>;
  propertyAvailabilitiesConnection?: Maybe<PropertyAvailabilityConnection>;
  propertyAvailability?: Maybe<PropertyAvailability>;
  propertyCategories?: Maybe<Array<Maybe<PropertyCategory>>>;
  propertyCategoriesConnection?: Maybe<PropertyCategoryConnection>;
  propertyCategory?: Maybe<PropertyCategory>;
  propertyStatus?: Maybe<PropertyStatus>;
  propertyStatuses?: Maybe<Array<Maybe<PropertyStatus>>>;
  propertyStatusesConnection?: Maybe<PropertyStatusConnection>;
  province?: Maybe<Province>;
  provinces?: Maybe<Array<Maybe<Province>>>;
  provincesConnection?: Maybe<ProvinceConnection>;
  rentalTerm?: Maybe<RentalTerm>;
  rentalTerms?: Maybe<Array<Maybe<RentalTerm>>>;
  rentalTermsConnection?: Maybe<RentalTermConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  searchLocation?: Maybe<Array<Maybe<SearchPayload>>>;
  sellInterestCase?: Maybe<SellInterestCase>;
  sellInterestCases?: Maybe<Array<Maybe<SellInterestCase>>>;
  sellInterestCasesConnection?: Maybe<SellInterestCaseConnection>;
  suburb?: Maybe<Suburb>;
  suburbs?: Maybe<Array<Maybe<Suburb>>>;
  suburbsConnection?: Maybe<SuburbConnection>;
  team?: Maybe<Team>;
  teams?: Maybe<Array<Maybe<Team>>>;
  teamsConnection?: Maybe<TeamConnection>;
  typeOfProperties?: Maybe<Array<Maybe<TypeOfProperty>>>;
  typeOfPropertiesConnection?: Maybe<TypeOfPropertyConnection>;
  typeOfProperty?: Maybe<TypeOfProperty>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
};


export type QueryAgenciesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAgenciesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAgencyArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryAgentArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryAgentsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryAgentsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCitiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCitiesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCityArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCountAgentPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountriesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountriesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCountryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDistrictArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryDistrictsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryDistrictsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEmailNotificationSubscriptionArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryEmailNotificationSubscriptionsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryEmailNotificationSubscriptionsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindCityBySlugArgs = {
  slug: Scalars['String'];
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindDistrictBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryFindPropertCategoryBySlugArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindProvinceBySlugArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFindSuburbBySlugArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetAgencyAgentsArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetAgencyAgentsCountArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetAgentPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetAgentPropertyArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryGetAgentPropertyInterestCasesArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryGetAgentPropertyInterestCasesCountArgs = {
  where?: Maybe<Scalars['JSON']>;
};


export type QueryInterestCaseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryInterestCasesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryInterestCasesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryNotificationsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryNotificationsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertiesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertyArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPropertyAvailabilitiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertyAvailabilitiesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertyAvailabilityArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPropertyCategoriesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertyCategoriesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertyCategoryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPropertyStatusArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPropertyStatusesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPropertyStatusesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProvinceArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryProvincesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryProvincesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRentalTermArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRentalTermsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRentalTermsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySearchLocationArgs = {
  locationData?: Maybe<LocationDataInput>;
  searchTerm: Scalars['String'];
};


export type QuerySellInterestCaseArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerySellInterestCasesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySellInterestCasesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySuburbArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QuerySuburbsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QuerySuburbsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTeamArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTeamsArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTeamsConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTypeOfPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTypeOfPropertiesConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTypeOfPropertyArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  limit?: Maybe<Scalars['Int']>;
  publicationState?: Maybe<PublicationState>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RentalTerm = {
  __typename?: 'RentalTerm';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name_en: Scalars['String'];
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};


export type RentalTermPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RentalTermAggregator = {
  __typename?: 'RentalTermAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RentalTermConnection = {
  __typename?: 'RentalTermConnection';
  aggregate?: Maybe<RentalTermAggregator>;
  groupBy?: Maybe<RentalTermGroupBy>;
  values?: Maybe<Array<Maybe<RentalTerm>>>;
};

export type RentalTermConnectionCreated_At = {
  __typename?: 'RentalTermConnectionCreated_at';
  connection?: Maybe<RentalTermConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type RentalTermConnectionId = {
  __typename?: 'RentalTermConnectionId';
  connection?: Maybe<RentalTermConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type RentalTermConnectionName_En = {
  __typename?: 'RentalTermConnectionName_en';
  connection?: Maybe<RentalTermConnection>;
  key?: Maybe<Scalars['String']>;
};

export type RentalTermConnectionName_Fr = {
  __typename?: 'RentalTermConnectionName_fr';
  connection?: Maybe<RentalTermConnection>;
  key?: Maybe<Scalars['String']>;
};

export type RentalTermConnectionPublished_At = {
  __typename?: 'RentalTermConnectionPublished_at';
  connection?: Maybe<RentalTermConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type RentalTermConnectionUpdated_At = {
  __typename?: 'RentalTermConnectionUpdated_at';
  connection?: Maybe<RentalTermConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type RentalTermGroupBy = {
  __typename?: 'RentalTermGroupBy';
  created_at?: Maybe<Array<Maybe<RentalTermConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<RentalTermConnectionId>>>;
  name_en?: Maybe<Array<Maybe<RentalTermConnectionName_En>>>;
  name_fr?: Maybe<Array<Maybe<RentalTermConnectionName_Fr>>>;
  published_at?: Maybe<Array<Maybe<RentalTermConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<RentalTermConnectionUpdated_At>>>;
};

export type RentalTermInput = {
  created_by?: Maybe<Scalars['ID']>;
  name_en: Scalars['String'];
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type RoleInput = {
  created_by?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type SearchPayload = {
  __typename?: 'SearchPayload';
  _key?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  district?: Maybe<District>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Province>;
  slug?: Maybe<Scalars['String']>;
  typename?: Maybe<Scalars['String']>;
};

export type SellInterestCase = {
  __typename?: 'SellInterestCase';
  case_number?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
  users_permissions_user?: Maybe<UsersPermissionsUser>;
};

export type SellInterestCaseAggregator = {
  __typename?: 'SellInterestCaseAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SellInterestCaseConnection = {
  __typename?: 'SellInterestCaseConnection';
  aggregate?: Maybe<SellInterestCaseAggregator>;
  groupBy?: Maybe<SellInterestCaseGroupBy>;
  values?: Maybe<Array<Maybe<SellInterestCase>>>;
};

export type SellInterestCaseConnectionCase_Number = {
  __typename?: 'SellInterestCaseConnectionCase_number';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SellInterestCaseConnectionCreated_At = {
  __typename?: 'SellInterestCaseConnectionCreated_at';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SellInterestCaseConnectionEmail = {
  __typename?: 'SellInterestCaseConnectionEmail';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SellInterestCaseConnectionFull_Name = {
  __typename?: 'SellInterestCaseConnectionFull_name';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SellInterestCaseConnectionId = {
  __typename?: 'SellInterestCaseConnectionId';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SellInterestCaseConnectionMessage = {
  __typename?: 'SellInterestCaseConnectionMessage';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SellInterestCaseConnectionPhone_Number = {
  __typename?: 'SellInterestCaseConnectionPhone_number';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SellInterestCaseConnectionPublished_At = {
  __typename?: 'SellInterestCaseConnectionPublished_at';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SellInterestCaseConnectionUpdated_At = {
  __typename?: 'SellInterestCaseConnectionUpdated_at';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SellInterestCaseConnectionUsers_Permissions_User = {
  __typename?: 'SellInterestCaseConnectionUsers_permissions_user';
  connection?: Maybe<SellInterestCaseConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SellInterestCaseGroupBy = {
  __typename?: 'SellInterestCaseGroupBy';
  case_number?: Maybe<Array<Maybe<SellInterestCaseConnectionCase_Number>>>;
  created_at?: Maybe<Array<Maybe<SellInterestCaseConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<SellInterestCaseConnectionEmail>>>;
  full_name?: Maybe<Array<Maybe<SellInterestCaseConnectionFull_Name>>>;
  id?: Maybe<Array<Maybe<SellInterestCaseConnectionId>>>;
  message?: Maybe<Array<Maybe<SellInterestCaseConnectionMessage>>>;
  phone_number?: Maybe<Array<Maybe<SellInterestCaseConnectionPhone_Number>>>;
  published_at?: Maybe<Array<Maybe<SellInterestCaseConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<SellInterestCaseConnectionUpdated_At>>>;
  users_permissions_user?: Maybe<Array<Maybe<SellInterestCaseConnectionUsers_Permissions_User>>>;
};

export type SellInterestCaseInput = {
  case_number?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
};

export type Suburb = {
  __typename?: 'Suburb';
  city?: Maybe<City>;
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['Long']>;
  properties?: Maybe<Array<Maybe<Property>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};


export type SuburbPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type SuburbAggregator = {
  __typename?: 'SuburbAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SuburbConnection = {
  __typename?: 'SuburbConnection';
  aggregate?: Maybe<SuburbAggregator>;
  groupBy?: Maybe<SuburbGroupBy>;
  values?: Maybe<Array<Maybe<Suburb>>>;
};

export type SuburbConnectionCity = {
  __typename?: 'SuburbConnectionCity';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SuburbConnectionCreated_At = {
  __typename?: 'SuburbConnectionCreated_at';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SuburbConnectionId = {
  __typename?: 'SuburbConnectionId';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SuburbConnectionName = {
  __typename?: 'SuburbConnectionName';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SuburbConnectionPostal_Code = {
  __typename?: 'SuburbConnectionPostal_code';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type SuburbConnectionPublished_At = {
  __typename?: 'SuburbConnectionPublished_at';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SuburbConnectionSlug = {
  __typename?: 'SuburbConnectionSlug';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['String']>;
};

export type SuburbConnectionUpdated_At = {
  __typename?: 'SuburbConnectionUpdated_at';
  connection?: Maybe<SuburbConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type SuburbGroupBy = {
  __typename?: 'SuburbGroupBy';
  city?: Maybe<Array<Maybe<SuburbConnectionCity>>>;
  created_at?: Maybe<Array<Maybe<SuburbConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<SuburbConnectionId>>>;
  name?: Maybe<Array<Maybe<SuburbConnectionName>>>;
  postal_code?: Maybe<Array<Maybe<SuburbConnectionPostal_Code>>>;
  published_at?: Maybe<Array<Maybe<SuburbConnectionPublished_At>>>;
  slug?: Maybe<Array<Maybe<SuburbConnectionSlug>>>;
  updated_at?: Maybe<Array<Maybe<SuburbConnectionUpdated_At>>>;
};

export type SuburbInput = {
  city?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['Long']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Team = {
  __typename?: 'Team';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  linkedin_link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  photo?: Maybe<UploadFile>;
  published_at?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  role_description?: Maybe<Scalars['String']>;
  twitter_link?: Maybe<Scalars['String']>;
  updated_at: Scalars['DateTime'];
};

export type TeamAggregator = {
  __typename?: 'TeamAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TeamConnection = {
  __typename?: 'TeamConnection';
  aggregate?: Maybe<TeamAggregator>;
  groupBy?: Maybe<TeamGroupBy>;
  values?: Maybe<Array<Maybe<Team>>>;
};

export type TeamConnectionCreated_At = {
  __typename?: 'TeamConnectionCreated_at';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TeamConnectionId = {
  __typename?: 'TeamConnectionId';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TeamConnectionLinkedin_Link = {
  __typename?: 'TeamConnectionLinkedin_link';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TeamConnectionName = {
  __typename?: 'TeamConnectionName';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TeamConnectionPhoto = {
  __typename?: 'TeamConnectionPhoto';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TeamConnectionPublished_At = {
  __typename?: 'TeamConnectionPublished_at';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TeamConnectionRole = {
  __typename?: 'TeamConnectionRole';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TeamConnectionRole_Description = {
  __typename?: 'TeamConnectionRole_description';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TeamConnectionTwitter_Link = {
  __typename?: 'TeamConnectionTwitter_link';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TeamConnectionUpdated_At = {
  __typename?: 'TeamConnectionUpdated_at';
  connection?: Maybe<TeamConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TeamGroupBy = {
  __typename?: 'TeamGroupBy';
  created_at?: Maybe<Array<Maybe<TeamConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TeamConnectionId>>>;
  linkedin_link?: Maybe<Array<Maybe<TeamConnectionLinkedin_Link>>>;
  name?: Maybe<Array<Maybe<TeamConnectionName>>>;
  photo?: Maybe<Array<Maybe<TeamConnectionPhoto>>>;
  published_at?: Maybe<Array<Maybe<TeamConnectionPublished_At>>>;
  role?: Maybe<Array<Maybe<TeamConnectionRole>>>;
  role_description?: Maybe<Array<Maybe<TeamConnectionRole_Description>>>;
  twitter_link?: Maybe<Array<Maybe<TeamConnectionTwitter_Link>>>;
  updated_at?: Maybe<Array<Maybe<TeamConnectionUpdated_At>>>;
};

export type TeamInput = {
  created_by?: Maybe<Scalars['ID']>;
  linkedin_link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  photo?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  role_description?: Maybe<Scalars['String']>;
  twitter_link?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type TypeOfProperty = {
  __typename?: 'TypeOfProperty';
  created_at: Scalars['DateTime'];
  id: Scalars['ID'];
  name_en: Scalars['String'];
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Property>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_at: Scalars['DateTime'];
};


export type TypeOfPropertyPropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type TypeOfPropertyAggregator = {
  __typename?: 'TypeOfPropertyAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TypeOfPropertyConnection = {
  __typename?: 'TypeOfPropertyConnection';
  aggregate?: Maybe<TypeOfPropertyAggregator>;
  groupBy?: Maybe<TypeOfPropertyGroupBy>;
  values?: Maybe<Array<Maybe<TypeOfProperty>>>;
};

export type TypeOfPropertyConnectionCreated_At = {
  __typename?: 'TypeOfPropertyConnectionCreated_at';
  connection?: Maybe<TypeOfPropertyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TypeOfPropertyConnectionId = {
  __typename?: 'TypeOfPropertyConnectionId';
  connection?: Maybe<TypeOfPropertyConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type TypeOfPropertyConnectionName_En = {
  __typename?: 'TypeOfPropertyConnectionName_en';
  connection?: Maybe<TypeOfPropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TypeOfPropertyConnectionName_Fr = {
  __typename?: 'TypeOfPropertyConnectionName_fr';
  connection?: Maybe<TypeOfPropertyConnection>;
  key?: Maybe<Scalars['String']>;
};

export type TypeOfPropertyConnectionPublished_At = {
  __typename?: 'TypeOfPropertyConnectionPublished_at';
  connection?: Maybe<TypeOfPropertyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TypeOfPropertyConnectionUpdated_At = {
  __typename?: 'TypeOfPropertyConnectionUpdated_at';
  connection?: Maybe<TypeOfPropertyConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type TypeOfPropertyGroupBy = {
  __typename?: 'TypeOfPropertyGroupBy';
  created_at?: Maybe<Array<Maybe<TypeOfPropertyConnectionCreated_At>>>;
  id?: Maybe<Array<Maybe<TypeOfPropertyConnectionId>>>;
  name_en?: Maybe<Array<Maybe<TypeOfPropertyConnectionName_En>>>;
  name_fr?: Maybe<Array<Maybe<TypeOfPropertyConnectionName_Fr>>>;
  published_at?: Maybe<Array<Maybe<TypeOfPropertyConnectionPublished_At>>>;
  updated_at?: Maybe<Array<Maybe<TypeOfPropertyConnectionUpdated_At>>>;
};

export type TypeOfPropertyInput = {
  created_by?: Maybe<Scalars['ID']>;
  name_en: Scalars['String'];
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateMyUserAgentInput = {
  agentNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_at: Scalars['DateTime'];
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
  size: Scalars['Float'];
  updated_at: Scalars['DateTime'];
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};


export type UploadFileRelatedArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  avg?: Maybe<UploadFileAggregatorAvg>;
  count?: Maybe<Scalars['Int']>;
  max?: Maybe<UploadFileAggregatorMax>;
  min?: Maybe<UploadFileAggregatorMin>;
  sum?: Maybe<UploadFileAggregatorSum>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  aggregate?: Maybe<UploadFileAggregator>;
  groupBy?: Maybe<UploadFileGroupBy>;
  values?: Maybe<Array<Maybe<UploadFile>>>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['JSON']>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Float']>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  connection?: Maybe<UploadFileConnection>;
  key?: Maybe<Scalars['Int']>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
};

export type UserInput = {
  agent?: Maybe<Scalars['ID']>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  favorites_properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  firstName?: Maybe<Scalars['String']>;
  interest_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  lastName?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboarded?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  provider?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['ID']>;
  sell_interest_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  updated_by?: Maybe<Scalars['ID']>;
  username: Scalars['String'];
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  controller: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  type: Scalars['String'];
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  username: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  type?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  connection?: Maybe<UsersPermissionsRoleConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  agent?: Maybe<Agent>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['DateTime'];
  email: Scalars['String'];
  favorites_properties?: Maybe<Array<Maybe<Property>>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interest_cases?: Maybe<Array<Maybe<InterestCase>>>;
  lastName?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  onboarded?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<UploadFile>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  sell_interest_cases?: Maybe<Array<Maybe<SellInterestCase>>>;
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
};


export type UsersPermissionsUserFavorites_PropertiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserInterest_CasesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserNotificationsArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsUserSell_Interest_CasesArgs = {
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};

export type UsersPermissionsUserConnectionAgent = {
  __typename?: 'UsersPermissionsUserConnectionAgent';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionFirstName = {
  __typename?: 'UsersPermissionsUserConnectionFirstName';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionLastName = {
  __typename?: 'UsersPermissionsUserConnectionLastName';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionOnboarded = {
  __typename?: 'UsersPermissionsUserConnectionOnboarded';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['Boolean']>;
};

export type UsersPermissionsUserConnectionPhoneNumber = {
  __typename?: 'UsersPermissionsUserConnectionPhoneNumber';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionProfilePicture = {
  __typename?: 'UsersPermissionsUserConnectionProfilePicture';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['ID']>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['DateTime']>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  connection?: Maybe<UsersPermissionsUserConnection>;
  key?: Maybe<Scalars['String']>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  agent?: Maybe<Array<Maybe<UsersPermissionsUserConnectionAgent>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  firstName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFirstName>>>;
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  lastName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLastName>>>;
  onboarded?: Maybe<Array<Maybe<UsersPermissionsUserConnectionOnboarded>>>;
  phoneNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoneNumber>>>;
  profilePicture?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProfilePicture>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
};

export type CreateAgencyAgentInput = {
  agent_number: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone_number: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type CreateAgencyInput = {
  data?: Maybe<AgencyInput>;
};

export type CreateAgencyPayload = {
  __typename?: 'createAgencyPayload';
  agency?: Maybe<Agency>;
};

export type CreateAgentInput = {
  data?: Maybe<AgentInput>;
};

export type CreateAgentPayload = {
  __typename?: 'createAgentPayload';
  agent?: Maybe<Agent>;
};

export type CreateAgentUserInput = {
  agentNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CreateCityInput = {
  data?: Maybe<CityInput>;
};

export type CreateCityPayload = {
  __typename?: 'createCityPayload';
  city?: Maybe<City>;
};

export type CreateCountryInput = {
  data?: Maybe<CountryInput>;
};

export type CreateCountryPayload = {
  __typename?: 'createCountryPayload';
  country?: Maybe<Country>;
};

export type CreateDistrictInput = {
  data?: Maybe<DistrictInput>;
};

export type CreateDistrictPayload = {
  __typename?: 'createDistrictPayload';
  district?: Maybe<District>;
};

export type CreateEmailNotificationSubscriptionInput = {
  data?: Maybe<EmailNotificationSubscriptionInput>;
};

export type CreateEmailNotificationSubscriptionPayload = {
  __typename?: 'createEmailNotificationSubscriptionPayload';
  emailNotificationSubscription?: Maybe<EmailNotificationSubscription>;
};

export type CreateInterestCaseInput = {
  data?: Maybe<InterestCaseInput>;
};

export type CreateInterestCasePayload = {
  __typename?: 'createInterestCasePayload';
  interestCase?: Maybe<InterestCase>;
};

export type CreateNotificationInput = {
  data?: Maybe<NotificationInput>;
};

export type CreateNotificationPayload = {
  __typename?: 'createNotificationPayload';
  notification?: Maybe<Notification>;
};

export type CreatePropertyAvailabilityInput = {
  data?: Maybe<PropertyAvailabilityInput>;
};

export type CreatePropertyAvailabilityPayload = {
  __typename?: 'createPropertyAvailabilityPayload';
  propertyAvailability?: Maybe<PropertyAvailability>;
};

export type CreatePropertyCategoryInput = {
  data?: Maybe<PropertyCategoryInput>;
};

export type CreatePropertyCategoryPayload = {
  __typename?: 'createPropertyCategoryPayload';
  propertyCategory?: Maybe<PropertyCategory>;
};

export type CreatePropertyInput = {
  data?: Maybe<PropertyInput>;
};

export type CreatePropertyPayload = {
  __typename?: 'createPropertyPayload';
  property?: Maybe<Property>;
};

export type CreatePropertyStatusInput = {
  data?: Maybe<PropertyStatusInput>;
};

export type CreatePropertyStatusPayload = {
  __typename?: 'createPropertyStatusPayload';
  propertyStatus?: Maybe<PropertyStatus>;
};

export type CreateProvinceInput = {
  data?: Maybe<ProvinceInput>;
};

export type CreateProvincePayload = {
  __typename?: 'createProvincePayload';
  province?: Maybe<Province>;
};

export type CreateRentalTermInput = {
  data?: Maybe<RentalTermInput>;
};

export type CreateRentalTermPayload = {
  __typename?: 'createRentalTermPayload';
  rentalTerm?: Maybe<RentalTerm>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateSellInterestCaseInput = {
  data?: Maybe<SellInterestCaseInput>;
};

export type CreateSellInterestCasePayload = {
  __typename?: 'createSellInterestCasePayload';
  sellInterestCase?: Maybe<SellInterestCase>;
};

export type CreateSubscriptionInput = {
  countryCode: Scalars['String'];
  email: Scalars['String'];
};

export type CreateSuburbInput = {
  data?: Maybe<SuburbInput>;
};

export type CreateSuburbPayload = {
  __typename?: 'createSuburbPayload';
  suburb?: Maybe<Suburb>;
};

export type CreateTeamInput = {
  data?: Maybe<TeamInput>;
};

export type CreateTeamPayload = {
  __typename?: 'createTeamPayload';
  team?: Maybe<Team>;
};

export type CreateTypeOfPropertyInput = {
  data?: Maybe<TypeOfPropertyInput>;
};

export type CreateTypeOfPropertyPayload = {
  __typename?: 'createTypeOfPropertyPayload';
  typeOfProperty?: Maybe<TypeOfProperty>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteAgencyInput = {
  where?: Maybe<InputId>;
};

export type DeleteAgencyPayload = {
  __typename?: 'deleteAgencyPayload';
  agency?: Maybe<Agency>;
};

export type DeleteAgentInput = {
  where?: Maybe<InputId>;
};

export type DeleteAgentPayload = {
  __typename?: 'deleteAgentPayload';
  agent?: Maybe<Agent>;
};

export type DeleteCityInput = {
  where?: Maybe<InputId>;
};

export type DeleteCityPayload = {
  __typename?: 'deleteCityPayload';
  city?: Maybe<City>;
};

export type DeleteCountryInput = {
  where?: Maybe<InputId>;
};

export type DeleteCountryPayload = {
  __typename?: 'deleteCountryPayload';
  country?: Maybe<Country>;
};

export type DeleteDistrictInput = {
  where?: Maybe<InputId>;
};

export type DeleteDistrictPayload = {
  __typename?: 'deleteDistrictPayload';
  district?: Maybe<District>;
};

export type DeleteEmailNotificationSubscriptionInput = {
  where?: Maybe<InputId>;
};

export type DeleteEmailNotificationSubscriptionPayload = {
  __typename?: 'deleteEmailNotificationSubscriptionPayload';
  emailNotificationSubscription?: Maybe<EmailNotificationSubscription>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteInterestCaseInput = {
  where?: Maybe<InputId>;
};

export type DeleteInterestCasePayload = {
  __typename?: 'deleteInterestCasePayload';
  interestCase?: Maybe<InterestCase>;
};

export type DeleteNotificationInput = {
  where?: Maybe<InputId>;
};

export type DeleteNotificationPayload = {
  __typename?: 'deleteNotificationPayload';
  notification?: Maybe<Notification>;
};

export type DeletePropertyAvailabilityInput = {
  where?: Maybe<InputId>;
};

export type DeletePropertyAvailabilityPayload = {
  __typename?: 'deletePropertyAvailabilityPayload';
  propertyAvailability?: Maybe<PropertyAvailability>;
};

export type DeletePropertyCategoryInput = {
  where?: Maybe<InputId>;
};

export type DeletePropertyCategoryPayload = {
  __typename?: 'deletePropertyCategoryPayload';
  propertyCategory?: Maybe<PropertyCategory>;
};

export type DeletePropertyInput = {
  where?: Maybe<InputId>;
};

export type DeletePropertyPayload = {
  __typename?: 'deletePropertyPayload';
  property?: Maybe<Property>;
};

export type DeletePropertyStatusInput = {
  where?: Maybe<InputId>;
};

export type DeletePropertyStatusPayload = {
  __typename?: 'deletePropertyStatusPayload';
  propertyStatus?: Maybe<PropertyStatus>;
};

export type DeleteProvinceInput = {
  where?: Maybe<InputId>;
};

export type DeleteProvincePayload = {
  __typename?: 'deleteProvincePayload';
  province?: Maybe<Province>;
};

export type DeleteRentalTermInput = {
  where?: Maybe<InputId>;
};

export type DeleteRentalTermPayload = {
  __typename?: 'deleteRentalTermPayload';
  rentalTerm?: Maybe<RentalTerm>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteSellInterestCaseInput = {
  where?: Maybe<InputId>;
};

export type DeleteSellInterestCasePayload = {
  __typename?: 'deleteSellInterestCasePayload';
  sellInterestCase?: Maybe<SellInterestCase>;
};

export type DeleteSuburbInput = {
  where?: Maybe<InputId>;
};

export type DeleteSuburbPayload = {
  __typename?: 'deleteSuburbPayload';
  suburb?: Maybe<Suburb>;
};

export type DeleteTeamInput = {
  where?: Maybe<InputId>;
};

export type DeleteTeamPayload = {
  __typename?: 'deleteTeamPayload';
  team?: Maybe<Team>;
};

export type DeleteTypeOfPropertyInput = {
  where?: Maybe<InputId>;
};

export type DeleteTypeOfPropertyPayload = {
  __typename?: 'deleteTypeOfPropertyPayload';
  typeOfProperty?: Maybe<TypeOfProperty>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type EditAgencyInput = {
  address?: Maybe<Scalars['String']>;
  agents?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  website?: Maybe<Scalars['String']>;
};

export type EditAgentInput = {
  agency?: Maybe<Scalars['ID']>;
  agent_number?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['ID']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Enum_Agent_Status>;
  updated_by?: Maybe<Scalars['ID']>;
  user?: Maybe<Scalars['ID']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type EditCityInput = {
  created_by?: Maybe<Scalars['ID']>;
  district?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  suburbs?: Maybe<Array<Maybe<Scalars['ID']>>>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditCountryInput = {
  code?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  currency_symbol?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provinces?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditDistrictInput = {
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditEmailNotificationSubscriptionInput = {
  country?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  mime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  size?: Maybe<Scalars['Float']>;
  updated_by?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type EditInterestCaseInput = {
  caseID?: Maybe<Scalars['String']>;
  case_status?: Maybe<Enum_Interestcase_Case_Status>;
  cell_number?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
};

export type EditNotificationInput = {
  created_by?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
};

export type EditPermissionInput = {
  action?: Maybe<Scalars['String']>;
  controller?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  enabled?: Maybe<Scalars['Boolean']>;
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['ID']>;
  type?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPropertyAvailabilityInput = {
  created_by?: Maybe<Scalars['ID']>;
  name_en?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPropertyCategoryInput = {
  created_by?: Maybe<Scalars['ID']>;
  heading?: Maybe<Scalars['String']>;
  icon_index?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Propertycategory_Type>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPropertyInput = {
  agent?: Maybe<Scalars['ID']>;
  bathrooms?: Maybe<Scalars['Long']>;
  bedrooms?: Maybe<Scalars['Long']>;
  created_by?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  dining_rooms?: Maybe<Scalars['Long']>;
  floor_size?: Maybe<Scalars['Long']>;
  furnished?: Maybe<Scalars['Boolean']>;
  interest_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  interested_users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  kitchens?: Maybe<Scalars['Long']>;
  lease_period?: Maybe<Scalars['String']>;
  lifestyle?: Maybe<Scalars['String']>;
  lounges?: Maybe<Scalars['Long']>;
  occupation_date?: Maybe<Scalars['Date']>;
  parking?: Maybe<Scalars['Long']>;
  photos?: Maybe<Array<Maybe<Scalars['ID']>>>;
  pool?: Maybe<Scalars['Boolean']>;
  price?: Maybe<Scalars['Float']>;
  property_availability?: Maybe<Scalars['ID']>;
  property_category?: Maybe<Scalars['ID']>;
  publish_state?: Maybe<Enum_Property_Publish_State>;
  published_at?: Maybe<Scalars['DateTime']>;
  reference_number?: Maybe<Scalars['Long']>;
  rental_term?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  street_address?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['ID']>;
  type_of_property?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPropertyStatusInput = {
  created_by?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  status_en?: Maybe<Scalars['String']>;
  status_fr?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditProvinceInput = {
  cities?: Maybe<Array<Maybe<Scalars['ID']>>>;
  country?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  districts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  name?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRentalTermInput = {
  created_by?: Maybe<Scalars['ID']>;
  name_en?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  created_by?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  type?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type EditSellInterestCaseInput = {
  case_number?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
  users_permissions_user?: Maybe<Scalars['ID']>;
};

export type EditSuburbInput = {
  city?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['Long']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTeamInput = {
  created_by?: Maybe<Scalars['ID']>;
  linkedin_link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['ID']>;
  published_at?: Maybe<Scalars['DateTime']>;
  role?: Maybe<Scalars['String']>;
  role_description?: Maybe<Scalars['String']>;
  twitter_link?: Maybe<Scalars['String']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTypeOfPropertyInput = {
  created_by?: Maybe<Scalars['ID']>;
  name_en?: Maybe<Scalars['String']>;
  name_fr?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  published_at?: Maybe<Scalars['DateTime']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  agent?: Maybe<Scalars['ID']>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  favorites_properties?: Maybe<Array<Maybe<Scalars['ID']>>>;
  firstName?: Maybe<Scalars['String']>;
  interest_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  lastName?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<Scalars['ID']>>>;
  onboarded?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['ID']>;
  provider?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['ID']>;
  sell_interest_cases?: Maybe<Array<Maybe<Scalars['ID']>>>;
  updated_by?: Maybe<Scalars['ID']>;
  username?: Maybe<Scalars['String']>;
};

export type UpdateAdminAgencyInput = {
  address?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type UpdateAgencyAgentInput = {
  agent_number?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type UpdateAgencyInput = {
  data?: Maybe<EditAgencyInput>;
  where?: Maybe<InputId>;
};

export type UpdateAgencyPayload = {
  __typename?: 'updateAgencyPayload';
  agency?: Maybe<Agency>;
};

export type UpdateAgentInput = {
  data?: Maybe<EditAgentInput>;
  where?: Maybe<InputId>;
};

export type UpdateAgentPayload = {
  __typename?: 'updateAgentPayload';
  agent?: Maybe<Agent>;
};

export type UpdateAgentPropertyInput = {
  id: Scalars['ID'];
  input?: Maybe<UpdatePropertyInput>;
};

export type UpdateCityInput = {
  data?: Maybe<EditCityInput>;
  where?: Maybe<InputId>;
};

export type UpdateCityPayload = {
  __typename?: 'updateCityPayload';
  city?: Maybe<City>;
};

export type UpdateCountryInput = {
  data?: Maybe<EditCountryInput>;
  where?: Maybe<InputId>;
};

export type UpdateCountryPayload = {
  __typename?: 'updateCountryPayload';
  country?: Maybe<Country>;
};

export type UpdateDistrictInput = {
  data?: Maybe<EditDistrictInput>;
  where?: Maybe<InputId>;
};

export type UpdateDistrictPayload = {
  __typename?: 'updateDistrictPayload';
  district?: Maybe<District>;
};

export type UpdateEmailNotificationSubscriptionInput = {
  data?: Maybe<EditEmailNotificationSubscriptionInput>;
  where?: Maybe<InputId>;
};

export type UpdateEmailNotificationSubscriptionPayload = {
  __typename?: 'updateEmailNotificationSubscriptionPayload';
  emailNotificationSubscription?: Maybe<EmailNotificationSubscription>;
};

export type UpdateInterestCaseInput = {
  data?: Maybe<EditInterestCaseInput>;
  where?: Maybe<InputId>;
};

export type UpdateInterestCasePayload = {
  __typename?: 'updateInterestCasePayload';
  interestCase?: Maybe<InterestCase>;
};

export type UpdateMyUserInput = {
  agent?: Maybe<UpdateMyUserAgentInput>;
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  favorites_properties?: Maybe<Array<Maybe<Scalars['String']>>>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  onboarded?: Maybe<Scalars['Boolean']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  receiveSmsNotifications?: Maybe<Scalars['Boolean']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type UpdateNotificationInput = {
  data?: Maybe<EditNotificationInput>;
  where?: Maybe<InputId>;
};

export type UpdateNotificationPayload = {
  __typename?: 'updateNotificationPayload';
  notification?: Maybe<Notification>;
};

export type UpdatePropertyAvailabilityInput = {
  data?: Maybe<EditPropertyAvailabilityInput>;
  where?: Maybe<InputId>;
};

export type UpdatePropertyAvailabilityPayload = {
  __typename?: 'updatePropertyAvailabilityPayload';
  propertyAvailability?: Maybe<PropertyAvailability>;
};

export type UpdatePropertyCategoryInput = {
  data?: Maybe<EditPropertyCategoryInput>;
  where?: Maybe<InputId>;
};

export type UpdatePropertyCategoryPayload = {
  __typename?: 'updatePropertyCategoryPayload';
  propertyCategory?: Maybe<PropertyCategory>;
};

export type UpdatePropertyInput = {
  data?: Maybe<EditPropertyInput>;
  where?: Maybe<InputId>;
};

export type UpdatePropertyPayload = {
  __typename?: 'updatePropertyPayload';
  property?: Maybe<Property>;
};

export type UpdatePropertyStatusInput = {
  data?: Maybe<EditPropertyStatusInput>;
  where?: Maybe<InputId>;
};

export type UpdatePropertyStatusPayload = {
  __typename?: 'updatePropertyStatusPayload';
  propertyStatus?: Maybe<PropertyStatus>;
};

export type UpdateProvinceInput = {
  data?: Maybe<EditProvinceInput>;
  where?: Maybe<InputId>;
};

export type UpdateProvincePayload = {
  __typename?: 'updateProvincePayload';
  province?: Maybe<Province>;
};

export type UpdateRentalTermInput = {
  data?: Maybe<EditRentalTermInput>;
  where?: Maybe<InputId>;
};

export type UpdateRentalTermPayload = {
  __typename?: 'updateRentalTermPayload';
  rentalTerm?: Maybe<RentalTerm>;
};

export type UpdateRoleInput = {
  data?: Maybe<EditRoleInput>;
  where?: Maybe<InputId>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateSellInterestCaseInput = {
  data?: Maybe<EditSellInterestCaseInput>;
  where?: Maybe<InputId>;
};

export type UpdateSellInterestCasePayload = {
  __typename?: 'updateSellInterestCasePayload';
  sellInterestCase?: Maybe<SellInterestCase>;
};

export type UpdateSuburbInput = {
  data?: Maybe<EditSuburbInput>;
  where?: Maybe<InputId>;
};

export type UpdateSuburbPayload = {
  __typename?: 'updateSuburbPayload';
  suburb?: Maybe<Suburb>;
};

export type UpdateTeamInput = {
  data?: Maybe<EditTeamInput>;
  where?: Maybe<InputId>;
};

export type UpdateTeamPayload = {
  __typename?: 'updateTeamPayload';
  team?: Maybe<Team>;
};

export type UpdateTypeOfPropertyInput = {
  data?: Maybe<EditTypeOfPropertyInput>;
  where?: Maybe<InputId>;
};

export type UpdateTypeOfPropertyPayload = {
  __typename?: 'updateTypeOfPropertyPayload';
  typeOfProperty?: Maybe<TypeOfProperty>;
};

export type UpdateUserInput = {
  data?: Maybe<EditUserInput>;
  where?: Maybe<InputId>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type AgencyFragment = { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined };

export type AgentFragment = { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined };

export type CityFragment = { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined };

export type CountryFragment = { __typename?: 'Country', name?: string | null | undefined, code?: string | null | undefined, id: string };

export type DistrictFragment = { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined };

export type InterestCaseFragment = { __typename?: 'InterestCase', id: string, created_at: any, updated_at: any, full_name?: string | null | undefined, cell_number?: string | null | undefined, message?: string | null | undefined, email?: string | null | undefined, case_status?: Enum_Interestcase_Case_Status | null | undefined, caseID?: string | null | undefined };

export type PropertyFragment = { __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined };

export type PropertyAvailabilityFragment = { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any };

export type PropertyCategoryFragment = { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined };

export type ProvinceFragment = { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined };

export type RentalTermFragment = { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any };

export type SuburbFragment = { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined };

export type TeamFragment = { __typename?: 'Team', id: string, name: string, role_description?: string | null | undefined, role?: string | null | undefined, linkedin_link?: string | null | undefined, twitter_link?: string | null | undefined, published_at?: any | null | undefined, updated_at: any, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined };

export type TypeOfPropertyFragment = { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined };

export type UploadFileFragment = { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string };

export type UserFragment = { __typename?: 'UsersPermissionsUser', id: string, username: string, email: string, confirmed?: boolean | null | undefined, phoneNumber?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, blocked?: boolean | null | undefined, onboarded?: boolean | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, favorites_properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, role?: { __typename?: 'UsersPermissionsRole', id: string, name: string, description?: string | null | undefined, type?: string | null | undefined } | null | undefined };

export type AddAgentPropertyMutationVariables = Exact<{
  input?: Maybe<CreatePropertyInput>;
}>;


export type AddAgentPropertyMutation = { __typename?: 'Mutation', addAgentProperty?: { __typename?: 'Property', id: string } | null | undefined };

export type ArchiveAgencyAgentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveAgencyAgentMutation = { __typename?: 'Mutation', archiveAgencyAgent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, user?: { __typename?: 'UsersPermissionsUser', id: string, username: string, email: string, confirmed?: boolean | null | undefined, phoneNumber?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, blocked?: boolean | null | undefined, onboarded?: boolean | null | undefined, role?: { __typename?: 'UsersPermissionsRole', id: string, type?: string | null | undefined, name: string, description?: string | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, favorites_properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined };

export type ChangePropertyAgentsMutationVariables = Exact<{
  agent: Scalars['ID'];
  property: Scalars['ID'];
}>;


export type ChangePropertyAgentsMutation = { __typename?: 'Mutation', changePropertyAgents?: { __typename?: 'Property', id: string } | null | undefined };

export type CreateAgencyAgentMutationVariables = Exact<{
  input: CreateAgencyAgentInput;
}>;


export type CreateAgencyAgentMutation = { __typename?: 'Mutation', createAgencyAgent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined };

export type CreateInterestCaseMutationVariables = Exact<{
  input?: Maybe<CreateInterestCaseInput>;
}>;


export type CreateInterestCaseMutation = { __typename?: 'Mutation', createInterestCase?: { __typename?: 'createInterestCasePayload', interestCase?: { __typename?: 'InterestCase', id: string } | null | undefined } | null | undefined };

export type CreateSellInterestCaseMutationVariables = Exact<{
  input?: Maybe<CreateSellInterestCaseInput>;
}>;


export type CreateSellInterestCaseMutation = { __typename?: 'Mutation', createSellInterestCase?: { __typename?: 'createSellInterestCasePayload', sellInterestCase?: { __typename?: 'SellInterestCase', id: string } | null | undefined } | null | undefined };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription?: { __typename?: 'EmailNotificationSubscription', id: string } | null | undefined };

export type PublishAgentPropertyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublishAgentPropertyMutation = { __typename?: 'Mutation', publishAgentProperty?: { __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined };

export type CreateAgentUserMutationVariables = Exact<{
  input?: Maybe<CreateAgentUserInput>;
}>;


export type CreateAgentUserMutation = { __typename?: 'Mutation', createAgentUser?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined };

export type UnArchiveAgencyAgentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnArchiveAgencyAgentMutation = { __typename?: 'Mutation', unArchiveAgencyAgent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, user?: { __typename?: 'UsersPermissionsUser', id: string, username: string, email: string, confirmed?: boolean | null | undefined, phoneNumber?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, blocked?: boolean | null | undefined, onboarded?: boolean | null | undefined, role?: { __typename?: 'UsersPermissionsRole', id: string, type?: string | null | undefined, name: string, description?: string | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, favorites_properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined };

export type UnPublishAgentPropertyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnPublishAgentPropertyMutation = { __typename?: 'Mutation', unPublishAgentProperty?: { __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined };

export type UpdateAdminAgencyMutationVariables = Exact<{
  input: UpdateAdminAgencyInput;
}>;


export type UpdateAdminAgencyMutation = { __typename?: 'Mutation', updateAdminAgency?: { __typename?: 'Agency', id: string } | null | undefined };

export type UpdateAgencyAgentMutationVariables = Exact<{
  input: UpdateAgencyAgentInput;
}>;


export type UpdateAgencyAgentMutation = { __typename?: 'Mutation', updateAgencyAgent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined };

export type UpdateAgentPropertyMutationVariables = Exact<{
  input?: Maybe<UpdateAgentPropertyInput>;
}>;


export type UpdateAgentPropertyMutation = { __typename?: 'Mutation', updateAgentProperty?: { __typename?: 'Property', id: string } | null | undefined };

export type UpdateMyUserMutationVariables = Exact<{
  input?: Maybe<UpdateMyUserInput>;
}>;


export type UpdateMyUserMutation = { __typename?: 'Mutation', updateMyUser?: { __typename?: 'UsersPermissionsUser', id: string, username: string, email: string, confirmed?: boolean | null | undefined, phoneNumber?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, blocked?: boolean | null | undefined, onboarded?: boolean | null | undefined, favorites_properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, role?: { __typename?: 'UsersPermissionsRole', id: string, name: string, description?: string | null | undefined, type?: string | null | undefined } | null | undefined } | null | undefined };

export type CitiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type CitiesQuery = { __typename?: 'Query', cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined } | null | undefined, suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type CountAgentPropertiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type CountAgentPropertiesQuery = { __typename?: 'Query', countAgentProperties?: number | null | undefined };

export type CountPropertiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type CountPropertiesQuery = { __typename?: 'Query', countProperties?: number | null | undefined };

export type DistrictsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type DistrictsQuery = { __typename?: 'Query', districts?: Array<{ __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type FindCityBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FindCityBySlugQuery = { __typename?: 'Query', findCityBySlug?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined, suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FindDistrictBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FindDistrictBySlugQuery = { __typename?: 'Query', findDistrictBySlug?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FindPropertCategoryBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FindPropertCategoryBySlugQuery = { __typename?: 'Query', findPropertCategoryBySlug?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FindProvinceBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FindProvinceBySlugQuery = { __typename?: 'Query', findProvinceBySlug?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, districts?: Array<{ __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FindSuburbBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FindSuburbBySlugQuery = { __typename?: 'Query', findSuburbBySlug?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type FlatCitiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FlatCitiesQuery = { __typename?: 'Query', cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined> | null | undefined };

export type FlatDistrictsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FlatDistrictsQuery = { __typename?: 'Query', districts?: Array<{ __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type FlatProvincesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type FlatProvincesQuery = { __typename?: 'Query', provinces?: Array<{ __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, districts?: Array<{ __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetAgencyAgentsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type GetAgencyAgentsQuery = { __typename?: 'Query', getAgencyAgents?: Array<{ __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, user?: { __typename?: 'UsersPermissionsUser', id: string, username: string, email: string, confirmed?: boolean | null | undefined, phoneNumber?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, blocked?: boolean | null | undefined, onboarded?: boolean | null | undefined, role?: { __typename?: 'UsersPermissionsRole', id: string, type?: string | null | undefined, name: string, description?: string | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, favorites_properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined> | null | undefined };

export type GetAgencyAgentsCountQueryVariables = Exact<{
  where?: Maybe<Scalars['JSON']>;
}>;


export type GetAgencyAgentsCountQuery = { __typename?: 'Query', getAgencyAgentsCount?: number | null | undefined };

export type GetAgentPropertiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type GetAgentPropertiesQuery = { __typename?: 'Query', getAgentProperties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type GetAgentPropertyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAgentPropertyQuery = { __typename?: 'Query', getAgentProperty?: { __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined };

export type GetAgentPropertyInterestCasesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type GetAgentPropertyInterestCasesQuery = { __typename?: 'Query', getAgentPropertyInterestCases?: Array<{ __typename?: 'InterestCase', id: string, created_at: any, updated_at: any, full_name?: string | null | undefined, cell_number?: string | null | undefined, message?: string | null | undefined, email?: string | null | undefined, case_status?: Enum_Interestcase_Case_Status | null | undefined, caseID?: string | null | undefined } | null | undefined> | null | undefined };

export type GetAgentPropertyInterestCasesCountQueryVariables = Exact<{
  where?: Maybe<Scalars['JSON']>;
}>;


export type GetAgentPropertyInterestCasesCountQuery = { __typename?: 'Query', getAgentPropertyInterestCasesCount?: number | null | undefined };

export type GetMyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyUserQuery = { __typename?: 'Query', getMyUser?: { __typename?: 'UsersPermissionsUser', id: string, username: string, email: string, confirmed?: boolean | null | undefined, phoneNumber?: string | null | undefined, lastName?: string | null | undefined, firstName?: string | null | undefined, blocked?: boolean | null | undefined, onboarded?: boolean | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, favorites_properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined, role?: { __typename?: 'UsersPermissionsRole', id: string, name: string, description?: string | null | undefined, type?: string | null | undefined } | null | undefined } | null | undefined };

export type PropertiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type PropertiesQuery = { __typename?: 'Query', properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type PropertyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyQuery = { __typename?: 'Query', property?: { __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined, agent?: { __typename?: 'Agent', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, verified?: boolean | null | undefined, phone_number?: string | null | undefined, agent_number?: string | null | undefined, status?: Enum_Agent_Status | null | undefined, published_at?: any | null | undefined, agency?: { __typename?: 'Agency', id: string, created_at: any, updated_at: any, name?: string | null | undefined, email?: string | null | undefined, website?: string | null | undefined, address?: string | null | undefined, description?: string | null | undefined, phone_number?: string | null | undefined, published_at?: any | null | undefined, logo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, property_category?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined, property_availability?: { __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined };

export type PropertyAvailabilitiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type PropertyAvailabilitiesQuery = { __typename?: 'Query', propertyAvailabilities?: Array<{ __typename: 'PropertyAvailability', id: string, name_fr?: string | null | undefined, name_en?: string | null | undefined, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined> | null | undefined };

export type PropertyCategoriesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type PropertyCategoriesQuery = { __typename?: 'Query', propertyCategories?: Array<{ __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined } | null | undefined> | null | undefined };

export type PropertyCategoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyCategoryQuery = { __typename?: 'Query', propertyCategory?: { __typename: 'PropertyCategory', id: string, name?: string | null | undefined, type: Enum_Propertycategory_Type, heading?: string | null | undefined, created_at: any, updated_at: any, slug?: string | null | undefined, icon_index?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ProvincesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type ProvincesQuery = { __typename?: 'Query', provinces?: Array<{ __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, districts?: Array<{ __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, cities?: Array<{ __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, properties?: Array<{ __typename?: 'Property', id: string, created_at: any, updated_at: any, published_at?: any | null | undefined, slug?: string | null | undefined, pool?: boolean | null | undefined, furnished?: boolean | null | undefined, publish_state?: Enum_Property_Publish_State | null | undefined, reference_number?: any | null | undefined, occupation_date: any, floor_size?: any | null | undefined, street_address: string, lifestyle?: string | null | undefined, lease_period?: string | null | undefined, bathrooms?: any | null | undefined, bedrooms?: any | null | undefined, price?: number | null | undefined, kitchens?: any | null | undefined, lounges?: any | null | undefined, dining_rooms?: any | null | undefined, parking?: any | null | undefined, description?: string | null | undefined, suburb?: { __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined } | null | undefined, rental_term?: { __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined, type_of_property?: { __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined, photos?: Array<{ __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined> | null | undefined };

export type RentalTermsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type RentalTermsQuery = { __typename?: 'Query', rentalTerms?: Array<{ __typename: 'RentalTerm', id: string, name_fr?: string | null | undefined, name_en: string, published_at?: any | null | undefined, created_at: any, updated_at: any } | null | undefined> | null | undefined };

export type SearchLocationQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  locationData?: Maybe<LocationDataInput>;
}>;


export type SearchLocationQuery = { __typename?: 'Query', searchLocation?: Array<{ __typename: 'SearchPayload', slug?: string | null | undefined, name?: string | null | undefined, _key?: string | null | undefined, typename?: string | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined } | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined } | null | undefined } | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type SuburbsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type SuburbsQuery = { __typename?: 'Query', suburbs?: Array<{ __typename: 'Suburb', id: string, created_at: any, updated_at: any, postal_code?: any | null | undefined, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, city?: { __typename: 'City', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, district?: { __typename: 'District', id: string, created_at: any, updated_at: any, name?: string | null | undefined, published_at?: any | null | undefined, slug?: string | null | undefined, province?: { __typename: 'Province', id: string, created_at: any, updated_at: any, name?: string | null | undefined, slug?: string | null | undefined, published_at?: any | null | undefined, country?: { __typename?: 'Country', name?: string | null | undefined, code?: string | null | undefined, id: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export type TeamsQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type TeamsQuery = { __typename?: 'Query', teams?: Array<{ __typename?: 'Team', id: string, name: string, role_description?: string | null | undefined, role?: string | null | undefined, linkedin_link?: string | null | undefined, twitter_link?: string | null | undefined, published_at?: any | null | undefined, updated_at: any, photo?: { __typename?: 'UploadFile', id: string, created_at: any, updated_at: any, name: string, alternativeText?: string | null | undefined, caption?: string | null | undefined, width?: number | null | undefined, height?: number | null | undefined, formats?: any | null | undefined, hash: string, ext?: string | null | undefined, mime: string, size: number, url: string, previewUrl?: string | null | undefined, provider: string } | null | undefined } | null | undefined> | null | undefined };

export type TypeOfPropertiesQueryVariables = Exact<{
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
}>;


export type TypeOfPropertiesQuery = { __typename?: 'Query', typeOfProperties?: Array<{ __typename: 'TypeOfProperty', id: string, created_at: any, updated_at: any, name_en: string, name_fr?: string | null | undefined, published_at?: any | null | undefined } | null | undefined> | null | undefined };

export const CountryFragmentDoc = gql`
    fragment country on Country {
  name
  code
  id
}
    `;
export const DistrictFragmentDoc = gql`
    fragment district on District {
  id
  created_at
  updated_at
  name
  __typename
  published_at
  slug
}
    `;
export const InterestCaseFragmentDoc = gql`
    fragment interestCase on InterestCase {
  id
  created_at
  updated_at
  full_name
  cell_number
  message
  email
  case_status
  caseID
}
    `;
export const ProvinceFragmentDoc = gql`
    fragment province on Province {
  id
  created_at
  updated_at
  name
  slug
  __typename
  published_at
}
    `;
export const UploadFileFragmentDoc = gql`
    fragment uploadFile on UploadFile {
  id
  created_at
  updated_at
  name
  alternativeText
  caption
  width
  height
  formats
  hash
  ext
  mime
  size
  url
  previewUrl
  provider
}
    `;
export const TeamFragmentDoc = gql`
    fragment team on Team {
  id
  name
  role_description
  role
  linkedin_link
  twitter_link
  photo {
    ...uploadFile
  }
  published_at
  updated_at
}
    ${UploadFileFragmentDoc}`;
export const AgentFragmentDoc = gql`
    fragment agent on Agent {
  id
  created_at
  updated_at
  name
  email
  verified
  phone_number
  agent_number
  status
  photo {
    ...uploadFile
  }
  published_at
}
    ${UploadFileFragmentDoc}`;
export const AgencyFragmentDoc = gql`
    fragment agency on Agency {
  id
  created_at
  updated_at
  name
  email
  website
  address
  description
  logo {
    ...uploadFile
  }
  phone_number
  published_at
}
    ${UploadFileFragmentDoc}`;
export const PropertyFragmentDoc = gql`
    fragment property on Property {
  id
  created_at
  updated_at
  published_at
  slug
  pool
  furnished
  publish_state
  reference_number
  photos {
    ...uploadFile
  }
  occupation_date
  floor_size
  street_address
  lifestyle
  lease_period
  bathrooms
  bedrooms
  price
  kitchens
  lounges
  dining_rooms
  parking
  description
}
    ${UploadFileFragmentDoc}`;
export const SuburbFragmentDoc = gql`
    fragment suburb on Suburb {
  id
  created_at
  updated_at
  postal_code
  name
  slug
  __typename
  published_at
}
    `;
export const CityFragmentDoc = gql`
    fragment city on City {
  id
  created_at
  updated_at
  name
  __typename
  published_at
  slug
}
    `;
export const RentalTermFragmentDoc = gql`
    fragment rentalTerm on RentalTerm {
  id
  name_fr
  name_en
  __typename
  published_at
  created_at
  updated_at
}
    `;
export const PropertyCategoryFragmentDoc = gql`
    fragment propertyCategory on PropertyCategory {
  id
  name
  type
  heading
  __typename
  created_at
  updated_at
  slug
  icon_index
}
    `;
export const PropertyAvailabilityFragmentDoc = gql`
    fragment propertyAvailability on PropertyAvailability {
  id
  name_fr
  name_en
  __typename
  published_at
  created_at
  updated_at
}
    `;
export const TypeOfPropertyFragmentDoc = gql`
    fragment typeOfProperty on TypeOfProperty {
  id
  created_at
  updated_at
  name_en
  name_fr
  __typename
  published_at
}
    `;
export const UserFragmentDoc = gql`
    fragment user on UsersPermissionsUser {
  id
  username
  email
  confirmed
  phoneNumber
  lastName
  firstName
  blocked
  onboarded
  agent {
    ...agent
    agency {
      ...agency
      logo {
        ...uploadFile
      }
    }
  }
  favorites_properties {
    ...property
    suburb {
      ...suburb
      city {
        ...city
      }
    }
    agent {
      ...agent
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
  role {
    id
    name
    description
    type
  }
}
    ${AgentFragmentDoc}
${AgencyFragmentDoc}
${UploadFileFragmentDoc}
${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;
export const AddAgentPropertyDocument = gql`
    mutation addAgentProperty($input: createPropertyInput) {
  addAgentProperty(input: $input) {
    id
  }
}
    `;
export type AddAgentPropertyMutationFn = Apollo.MutationFunction<AddAgentPropertyMutation, AddAgentPropertyMutationVariables>;

/**
 * __useAddAgentPropertyMutation__
 *
 * To run a mutation, you first call `useAddAgentPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAgentPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAgentPropertyMutation, { data, loading, error }] = useAddAgentPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAgentPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddAgentPropertyMutation, AddAgentPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAgentPropertyMutation, AddAgentPropertyMutationVariables>(AddAgentPropertyDocument, options);
      }
export type AddAgentPropertyMutationHookResult = ReturnType<typeof useAddAgentPropertyMutation>;
export type AddAgentPropertyMutationResult = Apollo.MutationResult<AddAgentPropertyMutation>;
export type AddAgentPropertyMutationOptions = Apollo.BaseMutationOptions<AddAgentPropertyMutation, AddAgentPropertyMutationVariables>;
export const ArchiveAgencyAgentDocument = gql`
    mutation archiveAgencyAgent($id: ID!) {
  archiveAgencyAgent(id: $id) {
    ...agent
    properties {
      ...property
    }
    user {
      ...user
      role {
        id
        type
      }
    }
  }
}
    ${AgentFragmentDoc}
${PropertyFragmentDoc}
${UserFragmentDoc}`;
export type ArchiveAgencyAgentMutationFn = Apollo.MutationFunction<ArchiveAgencyAgentMutation, ArchiveAgencyAgentMutationVariables>;

/**
 * __useArchiveAgencyAgentMutation__
 *
 * To run a mutation, you first call `useArchiveAgencyAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAgencyAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAgencyAgentMutation, { data, loading, error }] = useArchiveAgencyAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveAgencyAgentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAgencyAgentMutation, ArchiveAgencyAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAgencyAgentMutation, ArchiveAgencyAgentMutationVariables>(ArchiveAgencyAgentDocument, options);
      }
export type ArchiveAgencyAgentMutationHookResult = ReturnType<typeof useArchiveAgencyAgentMutation>;
export type ArchiveAgencyAgentMutationResult = Apollo.MutationResult<ArchiveAgencyAgentMutation>;
export type ArchiveAgencyAgentMutationOptions = Apollo.BaseMutationOptions<ArchiveAgencyAgentMutation, ArchiveAgencyAgentMutationVariables>;
export const ChangePropertyAgentsDocument = gql`
    mutation changePropertyAgents($agent: ID!, $property: ID!) {
  changePropertyAgents(agent: $agent, property: $property) {
    id
  }
}
    `;
export type ChangePropertyAgentsMutationFn = Apollo.MutationFunction<ChangePropertyAgentsMutation, ChangePropertyAgentsMutationVariables>;

/**
 * __useChangePropertyAgentsMutation__
 *
 * To run a mutation, you first call `useChangePropertyAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePropertyAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePropertyAgentsMutation, { data, loading, error }] = useChangePropertyAgentsMutation({
 *   variables: {
 *      agent: // value for 'agent'
 *      property: // value for 'property'
 *   },
 * });
 */
export function useChangePropertyAgentsMutation(baseOptions?: Apollo.MutationHookOptions<ChangePropertyAgentsMutation, ChangePropertyAgentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePropertyAgentsMutation, ChangePropertyAgentsMutationVariables>(ChangePropertyAgentsDocument, options);
      }
export type ChangePropertyAgentsMutationHookResult = ReturnType<typeof useChangePropertyAgentsMutation>;
export type ChangePropertyAgentsMutationResult = Apollo.MutationResult<ChangePropertyAgentsMutation>;
export type ChangePropertyAgentsMutationOptions = Apollo.BaseMutationOptions<ChangePropertyAgentsMutation, ChangePropertyAgentsMutationVariables>;
export const CreateAgencyAgentDocument = gql`
    mutation createAgencyAgent($input: createAgencyAgentInput!) {
  createAgencyAgent(input: $input) {
    ...agent
  }
}
    ${AgentFragmentDoc}`;
export type CreateAgencyAgentMutationFn = Apollo.MutationFunction<CreateAgencyAgentMutation, CreateAgencyAgentMutationVariables>;

/**
 * __useCreateAgencyAgentMutation__
 *
 * To run a mutation, you first call `useCreateAgencyAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyAgentMutation, { data, loading, error }] = useCreateAgencyAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyAgentMutation, CreateAgencyAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyAgentMutation, CreateAgencyAgentMutationVariables>(CreateAgencyAgentDocument, options);
      }
export type CreateAgencyAgentMutationHookResult = ReturnType<typeof useCreateAgencyAgentMutation>;
export type CreateAgencyAgentMutationResult = Apollo.MutationResult<CreateAgencyAgentMutation>;
export type CreateAgencyAgentMutationOptions = Apollo.BaseMutationOptions<CreateAgencyAgentMutation, CreateAgencyAgentMutationVariables>;
export const CreateInterestCaseDocument = gql`
    mutation createInterestCase($input: createInterestCaseInput) {
  createInterestCase(input: $input) {
    interestCase {
      id
    }
  }
}
    `;
export type CreateInterestCaseMutationFn = Apollo.MutationFunction<CreateInterestCaseMutation, CreateInterestCaseMutationVariables>;

/**
 * __useCreateInterestCaseMutation__
 *
 * To run a mutation, you first call `useCreateInterestCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterestCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterestCaseMutation, { data, loading, error }] = useCreateInterestCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInterestCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateInterestCaseMutation, CreateInterestCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInterestCaseMutation, CreateInterestCaseMutationVariables>(CreateInterestCaseDocument, options);
      }
export type CreateInterestCaseMutationHookResult = ReturnType<typeof useCreateInterestCaseMutation>;
export type CreateInterestCaseMutationResult = Apollo.MutationResult<CreateInterestCaseMutation>;
export type CreateInterestCaseMutationOptions = Apollo.BaseMutationOptions<CreateInterestCaseMutation, CreateInterestCaseMutationVariables>;
export const CreateSellInterestCaseDocument = gql`
    mutation createSellInterestCase($input: createSellInterestCaseInput) {
  createSellInterestCase(input: $input) {
    sellInterestCase {
      id
    }
  }
}
    `;
export type CreateSellInterestCaseMutationFn = Apollo.MutationFunction<CreateSellInterestCaseMutation, CreateSellInterestCaseMutationVariables>;

/**
 * __useCreateSellInterestCaseMutation__
 *
 * To run a mutation, you first call `useCreateSellInterestCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSellInterestCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSellInterestCaseMutation, { data, loading, error }] = useCreateSellInterestCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSellInterestCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateSellInterestCaseMutation, CreateSellInterestCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSellInterestCaseMutation, CreateSellInterestCaseMutationVariables>(CreateSellInterestCaseDocument, options);
      }
export type CreateSellInterestCaseMutationHookResult = ReturnType<typeof useCreateSellInterestCaseMutation>;
export type CreateSellInterestCaseMutationResult = Apollo.MutationResult<CreateSellInterestCaseMutation>;
export type CreateSellInterestCaseMutationOptions = Apollo.BaseMutationOptions<CreateSellInterestCaseMutation, CreateSellInterestCaseMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: createSubscriptionInput!) {
  createSubscription(input: $input) {
    id
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const PublishAgentPropertyDocument = gql`
    mutation publishAgentProperty($id: ID!) {
  publishAgentProperty(id: $id) {
    ...property
    suburb {
      ...suburb
      city {
        ...city
      }
    }
    agent {
      ...agent
      agency {
        ...agency
      }
      properties {
        ...property
      }
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
}
    ${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;
export type PublishAgentPropertyMutationFn = Apollo.MutationFunction<PublishAgentPropertyMutation, PublishAgentPropertyMutationVariables>;

/**
 * __usePublishAgentPropertyMutation__
 *
 * To run a mutation, you first call `usePublishAgentPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAgentPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAgentPropertyMutation, { data, loading, error }] = usePublishAgentPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishAgentPropertyMutation(baseOptions?: Apollo.MutationHookOptions<PublishAgentPropertyMutation, PublishAgentPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishAgentPropertyMutation, PublishAgentPropertyMutationVariables>(PublishAgentPropertyDocument, options);
      }
export type PublishAgentPropertyMutationHookResult = ReturnType<typeof usePublishAgentPropertyMutation>;
export type PublishAgentPropertyMutationResult = Apollo.MutationResult<PublishAgentPropertyMutation>;
export type PublishAgentPropertyMutationOptions = Apollo.BaseMutationOptions<PublishAgentPropertyMutation, PublishAgentPropertyMutationVariables>;
export const CreateAgentUserDocument = gql`
    mutation createAgentUser($input: createAgentUserInput) {
  createAgentUser(input: $input) {
    ...agent
  }
}
    ${AgentFragmentDoc}`;
export type CreateAgentUserMutationFn = Apollo.MutationFunction<CreateAgentUserMutation, CreateAgentUserMutationVariables>;

/**
 * __useCreateAgentUserMutation__
 *
 * To run a mutation, you first call `useCreateAgentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentUserMutation, { data, loading, error }] = useCreateAgentUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgentUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentUserMutation, CreateAgentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentUserMutation, CreateAgentUserMutationVariables>(CreateAgentUserDocument, options);
      }
export type CreateAgentUserMutationHookResult = ReturnType<typeof useCreateAgentUserMutation>;
export type CreateAgentUserMutationResult = Apollo.MutationResult<CreateAgentUserMutation>;
export type CreateAgentUserMutationOptions = Apollo.BaseMutationOptions<CreateAgentUserMutation, CreateAgentUserMutationVariables>;
export const UnArchiveAgencyAgentDocument = gql`
    mutation unArchiveAgencyAgent($id: ID!) {
  unArchiveAgencyAgent(id: $id) {
    ...agent
    properties {
      ...property
    }
    user {
      ...user
      role {
        id
        type
      }
    }
  }
}
    ${AgentFragmentDoc}
${PropertyFragmentDoc}
${UserFragmentDoc}`;
export type UnArchiveAgencyAgentMutationFn = Apollo.MutationFunction<UnArchiveAgencyAgentMutation, UnArchiveAgencyAgentMutationVariables>;

/**
 * __useUnArchiveAgencyAgentMutation__
 *
 * To run a mutation, you first call `useUnArchiveAgencyAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnArchiveAgencyAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unArchiveAgencyAgentMutation, { data, loading, error }] = useUnArchiveAgencyAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnArchiveAgencyAgentMutation(baseOptions?: Apollo.MutationHookOptions<UnArchiveAgencyAgentMutation, UnArchiveAgencyAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnArchiveAgencyAgentMutation, UnArchiveAgencyAgentMutationVariables>(UnArchiveAgencyAgentDocument, options);
      }
export type UnArchiveAgencyAgentMutationHookResult = ReturnType<typeof useUnArchiveAgencyAgentMutation>;
export type UnArchiveAgencyAgentMutationResult = Apollo.MutationResult<UnArchiveAgencyAgentMutation>;
export type UnArchiveAgencyAgentMutationOptions = Apollo.BaseMutationOptions<UnArchiveAgencyAgentMutation, UnArchiveAgencyAgentMutationVariables>;
export const UnPublishAgentPropertyDocument = gql`
    mutation unPublishAgentProperty($id: ID!) {
  unPublishAgentProperty(id: $id) {
    ...property
    suburb {
      ...suburb
      city {
        ...city
      }
    }
    agent {
      ...agent
      agency {
        ...agency
      }
      properties {
        ...property
      }
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
}
    ${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;
export type UnPublishAgentPropertyMutationFn = Apollo.MutationFunction<UnPublishAgentPropertyMutation, UnPublishAgentPropertyMutationVariables>;

/**
 * __useUnPublishAgentPropertyMutation__
 *
 * To run a mutation, you first call `useUnPublishAgentPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnPublishAgentPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unPublishAgentPropertyMutation, { data, loading, error }] = useUnPublishAgentPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnPublishAgentPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UnPublishAgentPropertyMutation, UnPublishAgentPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnPublishAgentPropertyMutation, UnPublishAgentPropertyMutationVariables>(UnPublishAgentPropertyDocument, options);
      }
export type UnPublishAgentPropertyMutationHookResult = ReturnType<typeof useUnPublishAgentPropertyMutation>;
export type UnPublishAgentPropertyMutationResult = Apollo.MutationResult<UnPublishAgentPropertyMutation>;
export type UnPublishAgentPropertyMutationOptions = Apollo.BaseMutationOptions<UnPublishAgentPropertyMutation, UnPublishAgentPropertyMutationVariables>;
export const UpdateAdminAgencyDocument = gql`
    mutation updateAdminAgency($input: updateAdminAgencyInput!) {
  updateAdminAgency(input: $input) {
    id
  }
}
    `;
export type UpdateAdminAgencyMutationFn = Apollo.MutationFunction<UpdateAdminAgencyMutation, UpdateAdminAgencyMutationVariables>;

/**
 * __useUpdateAdminAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateAdminAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminAgencyMutation, { data, loading, error }] = useUpdateAdminAgencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminAgencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminAgencyMutation, UpdateAdminAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminAgencyMutation, UpdateAdminAgencyMutationVariables>(UpdateAdminAgencyDocument, options);
      }
export type UpdateAdminAgencyMutationHookResult = ReturnType<typeof useUpdateAdminAgencyMutation>;
export type UpdateAdminAgencyMutationResult = Apollo.MutationResult<UpdateAdminAgencyMutation>;
export type UpdateAdminAgencyMutationOptions = Apollo.BaseMutationOptions<UpdateAdminAgencyMutation, UpdateAdminAgencyMutationVariables>;
export const UpdateAgencyAgentDocument = gql`
    mutation updateAgencyAgent($input: updateAgencyAgentInput!) {
  updateAgencyAgent(input: $input) {
    ...agent
  }
}
    ${AgentFragmentDoc}`;
export type UpdateAgencyAgentMutationFn = Apollo.MutationFunction<UpdateAgencyAgentMutation, UpdateAgencyAgentMutationVariables>;

/**
 * __useUpdateAgencyAgentMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyAgentMutation, { data, loading, error }] = useUpdateAgencyAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyAgentMutation, UpdateAgencyAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyAgentMutation, UpdateAgencyAgentMutationVariables>(UpdateAgencyAgentDocument, options);
      }
export type UpdateAgencyAgentMutationHookResult = ReturnType<typeof useUpdateAgencyAgentMutation>;
export type UpdateAgencyAgentMutationResult = Apollo.MutationResult<UpdateAgencyAgentMutation>;
export type UpdateAgencyAgentMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyAgentMutation, UpdateAgencyAgentMutationVariables>;
export const UpdateAgentPropertyDocument = gql`
    mutation updateAgentProperty($input: updateAgentPropertyInput) {
  updateAgentProperty(input: $input) {
    id
  }
}
    `;
export type UpdateAgentPropertyMutationFn = Apollo.MutationFunction<UpdateAgentPropertyMutation, UpdateAgentPropertyMutationVariables>;

/**
 * __useUpdateAgentPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateAgentPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentPropertyMutation, { data, loading, error }] = useUpdateAgentPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgentPropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentPropertyMutation, UpdateAgentPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentPropertyMutation, UpdateAgentPropertyMutationVariables>(UpdateAgentPropertyDocument, options);
      }
export type UpdateAgentPropertyMutationHookResult = ReturnType<typeof useUpdateAgentPropertyMutation>;
export type UpdateAgentPropertyMutationResult = Apollo.MutationResult<UpdateAgentPropertyMutation>;
export type UpdateAgentPropertyMutationOptions = Apollo.BaseMutationOptions<UpdateAgentPropertyMutation, UpdateAgentPropertyMutationVariables>;
export const UpdateMyUserDocument = gql`
    mutation updateMyUser($input: updateMyUserInput) {
  updateMyUser(input: $input) {
    ...user
    favorites_properties {
      ...property
      suburb {
        ...suburb
        city {
          ...city
        }
      }
      agent {
        ...agent
      }
      rental_term {
        ...rentalTerm
      }
      property_category {
        ...propertyCategory
      }
      property_availability {
        ...propertyAvailability
      }
      type_of_property {
        ...typeOfProperty
      }
    }
  }
}
    ${UserFragmentDoc}
${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${AgentFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;
export type UpdateMyUserMutationFn = Apollo.MutationFunction<UpdateMyUserMutation, UpdateMyUserMutationVariables>;

/**
 * __useUpdateMyUserMutation__
 *
 * To run a mutation, you first call `useUpdateMyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyUserMutation, { data, loading, error }] = useUpdateMyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyUserMutation, UpdateMyUserMutationVariables>(UpdateMyUserDocument, options);
      }
export type UpdateMyUserMutationHookResult = ReturnType<typeof useUpdateMyUserMutation>;
export type UpdateMyUserMutationResult = Apollo.MutationResult<UpdateMyUserMutation>;
export type UpdateMyUserMutationOptions = Apollo.BaseMutationOptions<UpdateMyUserMutation, UpdateMyUserMutationVariables>;
export const CitiesDocument = gql`
    query Cities($sort: String, $limit: Int, $start: Int, $where: JSON) {
  cities(sort: $sort, limit: $limit, start: $start, where: $where) {
    district {
      ...district
      province {
        ...province
      }
    }
    ...city
    suburbs {
      ...suburb
      properties {
        ...property
        suburb {
          ...suburb
          city {
            ...city
          }
        }
        rental_term {
          ...rentalTerm
        }
        type_of_property {
          ...typeOfProperty
        }
      }
    }
  }
}
    ${DistrictFragmentDoc}
${ProvinceFragmentDoc}
${CityFragmentDoc}
${SuburbFragmentDoc}
${PropertyFragmentDoc}
${RentalTermFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useCitiesQuery__
 *
 * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCitiesQuery(baseOptions?: Apollo.QueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
      }
export function useCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitiesQuery, CitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, options);
        }
export type CitiesQueryHookResult = ReturnType<typeof useCitiesQuery>;
export type CitiesLazyQueryHookResult = ReturnType<typeof useCitiesLazyQuery>;
export type CitiesQueryResult = Apollo.QueryResult<CitiesQuery, CitiesQueryVariables>;
export const CountAgentPropertiesDocument = gql`
    query countAgentProperties($sort: String, $limit: Int, $start: Int, $where: JSON) {
  countAgentProperties(sort: $sort, limit: $limit, start: $start, where: $where)
}
    `;

/**
 * __useCountAgentPropertiesQuery__
 *
 * To run a query within a React component, call `useCountAgentPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountAgentPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountAgentPropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountAgentPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<CountAgentPropertiesQuery, CountAgentPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountAgentPropertiesQuery, CountAgentPropertiesQueryVariables>(CountAgentPropertiesDocument, options);
      }
export function useCountAgentPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountAgentPropertiesQuery, CountAgentPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountAgentPropertiesQuery, CountAgentPropertiesQueryVariables>(CountAgentPropertiesDocument, options);
        }
export type CountAgentPropertiesQueryHookResult = ReturnType<typeof useCountAgentPropertiesQuery>;
export type CountAgentPropertiesLazyQueryHookResult = ReturnType<typeof useCountAgentPropertiesLazyQuery>;
export type CountAgentPropertiesQueryResult = Apollo.QueryResult<CountAgentPropertiesQuery, CountAgentPropertiesQueryVariables>;
export const CountPropertiesDocument = gql`
    query countProperties($sort: String, $limit: Int, $start: Int, $where: JSON) {
  countProperties(sort: $sort, limit: $limit, start: $start, where: $where)
}
    `;

/**
 * __useCountPropertiesQuery__
 *
 * To run a query within a React component, call `useCountPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountPropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCountPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<CountPropertiesQuery, CountPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountPropertiesQuery, CountPropertiesQueryVariables>(CountPropertiesDocument, options);
      }
export function useCountPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountPropertiesQuery, CountPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountPropertiesQuery, CountPropertiesQueryVariables>(CountPropertiesDocument, options);
        }
export type CountPropertiesQueryHookResult = ReturnType<typeof useCountPropertiesQuery>;
export type CountPropertiesLazyQueryHookResult = ReturnType<typeof useCountPropertiesLazyQuery>;
export type CountPropertiesQueryResult = Apollo.QueryResult<CountPropertiesQuery, CountPropertiesQueryVariables>;
export const DistrictsDocument = gql`
    query Districts($sort: String, $limit: Int, $start: Int, $where: JSON) {
  districts(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...district
    province {
      ...province
    }
    cities {
      ...city
      suburbs {
        ...suburb
        properties {
          ...property
          suburb {
            ...suburb
            city {
              ...city
            }
          }
          rental_term {
            ...rentalTerm
          }
          type_of_property {
            ...typeOfProperty
          }
        }
      }
    }
  }
}
    ${DistrictFragmentDoc}
${ProvinceFragmentDoc}
${CityFragmentDoc}
${SuburbFragmentDoc}
${PropertyFragmentDoc}
${RentalTermFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useDistrictsQuery__
 *
 * To run a query within a React component, call `useDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistrictsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDistrictsQuery(baseOptions?: Apollo.QueryHookOptions<DistrictsQuery, DistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistrictsQuery, DistrictsQueryVariables>(DistrictsDocument, options);
      }
export function useDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistrictsQuery, DistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistrictsQuery, DistrictsQueryVariables>(DistrictsDocument, options);
        }
export type DistrictsQueryHookResult = ReturnType<typeof useDistrictsQuery>;
export type DistrictsLazyQueryHookResult = ReturnType<typeof useDistrictsLazyQuery>;
export type DistrictsQueryResult = Apollo.QueryResult<DistrictsQuery, DistrictsQueryVariables>;
export const FindCityBySlugDocument = gql`
    query FindCityBySlug($slug: String!, $sort: String, $limit: Int, $start: Int, $where: JSON) {
  findCityBySlug(slug: $slug) {
    ...city
    district {
      ...district
    }
    suburbs {
      ...suburb
      properties(sort: $sort, limit: $limit, start: $start, where: $where) {
        ...property
        suburb {
          ...suburb
          city {
            ...city
          }
        }
        rental_term {
          ...rentalTerm
        }
        property_availability {
          ...propertyAvailability
        }
        type_of_property {
          ...typeOfProperty
        }
      }
    }
  }
}
    ${CityFragmentDoc}
${DistrictFragmentDoc}
${SuburbFragmentDoc}
${PropertyFragmentDoc}
${RentalTermFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useFindCityBySlugQuery__
 *
 * To run a query within a React component, call `useFindCityBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCityBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCityBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindCityBySlugQuery(baseOptions: Apollo.QueryHookOptions<FindCityBySlugQuery, FindCityBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCityBySlugQuery, FindCityBySlugQueryVariables>(FindCityBySlugDocument, options);
      }
export function useFindCityBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCityBySlugQuery, FindCityBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCityBySlugQuery, FindCityBySlugQueryVariables>(FindCityBySlugDocument, options);
        }
export type FindCityBySlugQueryHookResult = ReturnType<typeof useFindCityBySlugQuery>;
export type FindCityBySlugLazyQueryHookResult = ReturnType<typeof useFindCityBySlugLazyQuery>;
export type FindCityBySlugQueryResult = Apollo.QueryResult<FindCityBySlugQuery, FindCityBySlugQueryVariables>;
export const FindDistrictBySlugDocument = gql`
    query FindDistrictBySlug($slug: String!, $sort: String, $limit: Int, $start: Int, $where: JSON) {
  findDistrictBySlug(slug: $slug) {
    ...district
    province {
      ...province
    }
    cities {
      ...city
      suburbs {
        ...suburb
        properties(sort: $sort, limit: $limit, start: $start, where: $where) {
          ...property
          suburb {
            ...suburb
            city {
              ...city
            }
          }
          property_availability {
            ...propertyAvailability
          }
          rental_term {
            ...rentalTerm
          }
          type_of_property {
            ...typeOfProperty
          }
        }
      }
    }
  }
}
    ${DistrictFragmentDoc}
${ProvinceFragmentDoc}
${CityFragmentDoc}
${SuburbFragmentDoc}
${PropertyFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${RentalTermFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useFindDistrictBySlugQuery__
 *
 * To run a query within a React component, call `useFindDistrictBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindDistrictBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindDistrictBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindDistrictBySlugQuery(baseOptions: Apollo.QueryHookOptions<FindDistrictBySlugQuery, FindDistrictBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindDistrictBySlugQuery, FindDistrictBySlugQueryVariables>(FindDistrictBySlugDocument, options);
      }
export function useFindDistrictBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindDistrictBySlugQuery, FindDistrictBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindDistrictBySlugQuery, FindDistrictBySlugQueryVariables>(FindDistrictBySlugDocument, options);
        }
export type FindDistrictBySlugQueryHookResult = ReturnType<typeof useFindDistrictBySlugQuery>;
export type FindDistrictBySlugLazyQueryHookResult = ReturnType<typeof useFindDistrictBySlugLazyQuery>;
export type FindDistrictBySlugQueryResult = Apollo.QueryResult<FindDistrictBySlugQuery, FindDistrictBySlugQueryVariables>;
export const FindPropertCategoryBySlugDocument = gql`
    query FindPropertCategoryBySlug($slug: String!, $sort: String, $limit: Int, $start: Int, $where: JSON) {
  findPropertCategoryBySlug(slug: $slug) {
    ...propertyCategory
    properties(sort: $sort, limit: $limit, start: $start, where: $where) {
      ...property
      suburb {
        ...suburb
        city {
          ...city
        }
      }
      rental_term {
        ...rentalTerm
      }
      property_availability {
        ...propertyAvailability
      }
      type_of_property {
        ...typeOfProperty
      }
    }
  }
}
    ${PropertyCategoryFragmentDoc}
${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${RentalTermFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useFindPropertCategoryBySlugQuery__
 *
 * To run a query within a React component, call `useFindPropertCategoryBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindPropertCategoryBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindPropertCategoryBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindPropertCategoryBySlugQuery(baseOptions: Apollo.QueryHookOptions<FindPropertCategoryBySlugQuery, FindPropertCategoryBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindPropertCategoryBySlugQuery, FindPropertCategoryBySlugQueryVariables>(FindPropertCategoryBySlugDocument, options);
      }
export function useFindPropertCategoryBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindPropertCategoryBySlugQuery, FindPropertCategoryBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindPropertCategoryBySlugQuery, FindPropertCategoryBySlugQueryVariables>(FindPropertCategoryBySlugDocument, options);
        }
export type FindPropertCategoryBySlugQueryHookResult = ReturnType<typeof useFindPropertCategoryBySlugQuery>;
export type FindPropertCategoryBySlugLazyQueryHookResult = ReturnType<typeof useFindPropertCategoryBySlugLazyQuery>;
export type FindPropertCategoryBySlugQueryResult = Apollo.QueryResult<FindPropertCategoryBySlugQuery, FindPropertCategoryBySlugQueryVariables>;
export const FindProvinceBySlugDocument = gql`
    query FindProvinceBySlug($slug: String!, $sort: String, $limit: Int, $start: Int, $where: JSON) {
  findProvinceBySlug(slug: $slug) {
    ...province
    districts {
      ...district
      cities {
        ...city
        suburbs {
          ...suburb
          properties(sort: $sort, limit: $limit, start: $start, where: $where) {
            ...property
            suburb {
              ...suburb
              city {
                ...city
              }
            }
            property_availability {
              ...propertyAvailability
            }
            rental_term {
              ...rentalTerm
            }
            type_of_property {
              ...typeOfProperty
            }
          }
        }
      }
    }
  }
}
    ${ProvinceFragmentDoc}
${DistrictFragmentDoc}
${CityFragmentDoc}
${SuburbFragmentDoc}
${PropertyFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${RentalTermFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useFindProvinceBySlugQuery__
 *
 * To run a query within a React component, call `useFindProvinceBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProvinceBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProvinceBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindProvinceBySlugQuery(baseOptions: Apollo.QueryHookOptions<FindProvinceBySlugQuery, FindProvinceBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProvinceBySlugQuery, FindProvinceBySlugQueryVariables>(FindProvinceBySlugDocument, options);
      }
export function useFindProvinceBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProvinceBySlugQuery, FindProvinceBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProvinceBySlugQuery, FindProvinceBySlugQueryVariables>(FindProvinceBySlugDocument, options);
        }
export type FindProvinceBySlugQueryHookResult = ReturnType<typeof useFindProvinceBySlugQuery>;
export type FindProvinceBySlugLazyQueryHookResult = ReturnType<typeof useFindProvinceBySlugLazyQuery>;
export type FindProvinceBySlugQueryResult = Apollo.QueryResult<FindProvinceBySlugQuery, FindProvinceBySlugQueryVariables>;
export const FindSuburbBySlugDocument = gql`
    query FindSuburbBySlug($slug: String!, $sort: String, $limit: Int, $start: Int, $where: JSON) {
  findSuburbBySlug(slug: $slug) {
    ...suburb
    properties(sort: $sort, limit: $limit, start: $start, where: $where) {
      ...property
      suburb {
        ...suburb
        city {
          ...city
        }
      }
      rental_term {
        ...rentalTerm
      }
      property_availability {
        ...propertyAvailability
      }
      type_of_property {
        ...typeOfProperty
      }
    }
  }
}
    ${SuburbFragmentDoc}
${PropertyFragmentDoc}
${CityFragmentDoc}
${RentalTermFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useFindSuburbBySlugQuery__
 *
 * To run a query within a React component, call `useFindSuburbBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSuburbBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSuburbBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindSuburbBySlugQuery(baseOptions: Apollo.QueryHookOptions<FindSuburbBySlugQuery, FindSuburbBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSuburbBySlugQuery, FindSuburbBySlugQueryVariables>(FindSuburbBySlugDocument, options);
      }
export function useFindSuburbBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSuburbBySlugQuery, FindSuburbBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSuburbBySlugQuery, FindSuburbBySlugQueryVariables>(FindSuburbBySlugDocument, options);
        }
export type FindSuburbBySlugQueryHookResult = ReturnType<typeof useFindSuburbBySlugQuery>;
export type FindSuburbBySlugLazyQueryHookResult = ReturnType<typeof useFindSuburbBySlugLazyQuery>;
export type FindSuburbBySlugQueryResult = Apollo.QueryResult<FindSuburbBySlugQuery, FindSuburbBySlugQueryVariables>;
export const FlatCitiesDocument = gql`
    query FlatCities($sort: String, $limit: Int, $start: Int, $where: JSON) {
  cities(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...city
  }
}
    ${CityFragmentDoc}`;

/**
 * __useFlatCitiesQuery__
 *
 * To run a query within a React component, call `useFlatCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatCitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFlatCitiesQuery(baseOptions?: Apollo.QueryHookOptions<FlatCitiesQuery, FlatCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatCitiesQuery, FlatCitiesQueryVariables>(FlatCitiesDocument, options);
      }
export function useFlatCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatCitiesQuery, FlatCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatCitiesQuery, FlatCitiesQueryVariables>(FlatCitiesDocument, options);
        }
export type FlatCitiesQueryHookResult = ReturnType<typeof useFlatCitiesQuery>;
export type FlatCitiesLazyQueryHookResult = ReturnType<typeof useFlatCitiesLazyQuery>;
export type FlatCitiesQueryResult = Apollo.QueryResult<FlatCitiesQuery, FlatCitiesQueryVariables>;
export const FlatDistrictsDocument = gql`
    query FlatDistricts($sort: String, $limit: Int, $start: Int, $where: JSON) {
  districts(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...district
    cities {
      ...city
    }
  }
}
    ${DistrictFragmentDoc}
${CityFragmentDoc}`;

/**
 * __useFlatDistrictsQuery__
 *
 * To run a query within a React component, call `useFlatDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatDistrictsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFlatDistrictsQuery(baseOptions?: Apollo.QueryHookOptions<FlatDistrictsQuery, FlatDistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatDistrictsQuery, FlatDistrictsQueryVariables>(FlatDistrictsDocument, options);
      }
export function useFlatDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatDistrictsQuery, FlatDistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatDistrictsQuery, FlatDistrictsQueryVariables>(FlatDistrictsDocument, options);
        }
export type FlatDistrictsQueryHookResult = ReturnType<typeof useFlatDistrictsQuery>;
export type FlatDistrictsLazyQueryHookResult = ReturnType<typeof useFlatDistrictsLazyQuery>;
export type FlatDistrictsQueryResult = Apollo.QueryResult<FlatDistrictsQuery, FlatDistrictsQueryVariables>;
export const FlatProvincesDocument = gql`
    query FlatProvinces($sort: String, $limit: Int, $start: Int, $where: JSON) {
  provinces(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...province
    districts {
      ...district
    }
  }
}
    ${ProvinceFragmentDoc}
${DistrictFragmentDoc}`;

/**
 * __useFlatProvincesQuery__
 *
 * To run a query within a React component, call `useFlatProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatProvincesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFlatProvincesQuery(baseOptions?: Apollo.QueryHookOptions<FlatProvincesQuery, FlatProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatProvincesQuery, FlatProvincesQueryVariables>(FlatProvincesDocument, options);
      }
export function useFlatProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatProvincesQuery, FlatProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatProvincesQuery, FlatProvincesQueryVariables>(FlatProvincesDocument, options);
        }
export type FlatProvincesQueryHookResult = ReturnType<typeof useFlatProvincesQuery>;
export type FlatProvincesLazyQueryHookResult = ReturnType<typeof useFlatProvincesLazyQuery>;
export type FlatProvincesQueryResult = Apollo.QueryResult<FlatProvincesQuery, FlatProvincesQueryVariables>;
export const GetAgencyAgentsDocument = gql`
    query getAgencyAgents($sort: String, $limit: Int, $start: Int, $where: JSON) {
  getAgencyAgents(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...agent
    properties {
      ...property
      suburb {
        ...suburb
      }
      type_of_property {
        ...typeOfProperty
      }
      property_category {
        ...propertyCategory
      }
    }
    user {
      ...user
      role {
        id
        type
      }
    }
  }
}
    ${AgentFragmentDoc}
${PropertyFragmentDoc}
${SuburbFragmentDoc}
${TypeOfPropertyFragmentDoc}
${PropertyCategoryFragmentDoc}
${UserFragmentDoc}`;

/**
 * __useGetAgencyAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgencyAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyAgentsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAgencyAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyAgentsQuery, GetAgencyAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyAgentsQuery, GetAgencyAgentsQueryVariables>(GetAgencyAgentsDocument, options);
      }
export function useGetAgencyAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyAgentsQuery, GetAgencyAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyAgentsQuery, GetAgencyAgentsQueryVariables>(GetAgencyAgentsDocument, options);
        }
export type GetAgencyAgentsQueryHookResult = ReturnType<typeof useGetAgencyAgentsQuery>;
export type GetAgencyAgentsLazyQueryHookResult = ReturnType<typeof useGetAgencyAgentsLazyQuery>;
export type GetAgencyAgentsQueryResult = Apollo.QueryResult<GetAgencyAgentsQuery, GetAgencyAgentsQueryVariables>;
export const GetAgencyAgentsCountDocument = gql`
    query getAgencyAgentsCount($where: JSON) {
  getAgencyAgentsCount(where: $where)
}
    `;

/**
 * __useGetAgencyAgentsCountQuery__
 *
 * To run a query within a React component, call `useGetAgencyAgentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyAgentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyAgentsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAgencyAgentsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyAgentsCountQuery, GetAgencyAgentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyAgentsCountQuery, GetAgencyAgentsCountQueryVariables>(GetAgencyAgentsCountDocument, options);
      }
export function useGetAgencyAgentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyAgentsCountQuery, GetAgencyAgentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyAgentsCountQuery, GetAgencyAgentsCountQueryVariables>(GetAgencyAgentsCountDocument, options);
        }
export type GetAgencyAgentsCountQueryHookResult = ReturnType<typeof useGetAgencyAgentsCountQuery>;
export type GetAgencyAgentsCountLazyQueryHookResult = ReturnType<typeof useGetAgencyAgentsCountLazyQuery>;
export type GetAgencyAgentsCountQueryResult = Apollo.QueryResult<GetAgencyAgentsCountQuery, GetAgencyAgentsCountQueryVariables>;
export const GetAgentPropertiesDocument = gql`
    query getAgentProperties($sort: String, $limit: Int, $start: Int, $where: JSON) {
  getAgentProperties(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...property
    agent {
      ...agent
      agency {
        ...agency
      }
    }
    suburb {
      ...suburb
      city {
        ...city
        district {
          ...district
        }
        province {
          ...province
        }
      }
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
}
    ${PropertyFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${DistrictFragmentDoc}
${ProvinceFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useGetAgentPropertiesQuery__
 *
 * To run a query within a React component, call `useGetAgentPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAgentPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentPropertiesQuery, GetAgentPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentPropertiesQuery, GetAgentPropertiesQueryVariables>(GetAgentPropertiesDocument, options);
      }
export function useGetAgentPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentPropertiesQuery, GetAgentPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentPropertiesQuery, GetAgentPropertiesQueryVariables>(GetAgentPropertiesDocument, options);
        }
export type GetAgentPropertiesQueryHookResult = ReturnType<typeof useGetAgentPropertiesQuery>;
export type GetAgentPropertiesLazyQueryHookResult = ReturnType<typeof useGetAgentPropertiesLazyQuery>;
export type GetAgentPropertiesQueryResult = Apollo.QueryResult<GetAgentPropertiesQuery, GetAgentPropertiesQueryVariables>;
export const GetAgentPropertyDocument = gql`
    query getAgentProperty($id: ID!) {
  getAgentProperty(id: $id) {
    ...property
    suburb {
      ...suburb
      city {
        ...city
      }
    }
    agent {
      ...agent
      agency {
        ...agency
      }
      properties {
        ...property
      }
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
}
    ${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useGetAgentPropertyQuery__
 *
 * To run a query within a React component, call `useGetAgentPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgentPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetAgentPropertyQuery, GetAgentPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentPropertyQuery, GetAgentPropertyQueryVariables>(GetAgentPropertyDocument, options);
      }
export function useGetAgentPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentPropertyQuery, GetAgentPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentPropertyQuery, GetAgentPropertyQueryVariables>(GetAgentPropertyDocument, options);
        }
export type GetAgentPropertyQueryHookResult = ReturnType<typeof useGetAgentPropertyQuery>;
export type GetAgentPropertyLazyQueryHookResult = ReturnType<typeof useGetAgentPropertyLazyQuery>;
export type GetAgentPropertyQueryResult = Apollo.QueryResult<GetAgentPropertyQuery, GetAgentPropertyQueryVariables>;
export const GetAgentPropertyInterestCasesDocument = gql`
    query getAgentPropertyInterestCases($sort: String, $limit: Int, $start: Int, $where: JSON) {
  getAgentPropertyInterestCases(
    sort: $sort
    limit: $limit
    start: $start
    where: $where
  ) {
    ...interestCase
  }
}
    ${InterestCaseFragmentDoc}`;

/**
 * __useGetAgentPropertyInterestCasesQuery__
 *
 * To run a query within a React component, call `useGetAgentPropertyInterestCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPropertyInterestCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPropertyInterestCasesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAgentPropertyInterestCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentPropertyInterestCasesQuery, GetAgentPropertyInterestCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentPropertyInterestCasesQuery, GetAgentPropertyInterestCasesQueryVariables>(GetAgentPropertyInterestCasesDocument, options);
      }
export function useGetAgentPropertyInterestCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentPropertyInterestCasesQuery, GetAgentPropertyInterestCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentPropertyInterestCasesQuery, GetAgentPropertyInterestCasesQueryVariables>(GetAgentPropertyInterestCasesDocument, options);
        }
export type GetAgentPropertyInterestCasesQueryHookResult = ReturnType<typeof useGetAgentPropertyInterestCasesQuery>;
export type GetAgentPropertyInterestCasesLazyQueryHookResult = ReturnType<typeof useGetAgentPropertyInterestCasesLazyQuery>;
export type GetAgentPropertyInterestCasesQueryResult = Apollo.QueryResult<GetAgentPropertyInterestCasesQuery, GetAgentPropertyInterestCasesQueryVariables>;
export const GetAgentPropertyInterestCasesCountDocument = gql`
    query getAgentPropertyInterestCasesCount($where: JSON) {
  getAgentPropertyInterestCasesCount(where: $where)
}
    `;

/**
 * __useGetAgentPropertyInterestCasesCountQuery__
 *
 * To run a query within a React component, call `useGetAgentPropertyInterestCasesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentPropertyInterestCasesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentPropertyInterestCasesCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAgentPropertyInterestCasesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentPropertyInterestCasesCountQuery, GetAgentPropertyInterestCasesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgentPropertyInterestCasesCountQuery, GetAgentPropertyInterestCasesCountQueryVariables>(GetAgentPropertyInterestCasesCountDocument, options);
      }
export function useGetAgentPropertyInterestCasesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentPropertyInterestCasesCountQuery, GetAgentPropertyInterestCasesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgentPropertyInterestCasesCountQuery, GetAgentPropertyInterestCasesCountQueryVariables>(GetAgentPropertyInterestCasesCountDocument, options);
        }
export type GetAgentPropertyInterestCasesCountQueryHookResult = ReturnType<typeof useGetAgentPropertyInterestCasesCountQuery>;
export type GetAgentPropertyInterestCasesCountLazyQueryHookResult = ReturnType<typeof useGetAgentPropertyInterestCasesCountLazyQuery>;
export type GetAgentPropertyInterestCasesCountQueryResult = Apollo.QueryResult<GetAgentPropertyInterestCasesCountQuery, GetAgentPropertyInterestCasesCountQueryVariables>;
export const GetMyUserDocument = gql`
    query getMyUser {
  getMyUser {
    ...user
    agent {
      ...agent
      agency {
        ...agency
        logo {
          ...uploadFile
        }
      }
    }
  }
}
    ${UserFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${UploadFileFragmentDoc}`;

/**
 * __useGetMyUserQuery__
 *
 * To run a query within a React component, call `useGetMyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUserQuery(baseOptions?: Apollo.QueryHookOptions<GetMyUserQuery, GetMyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyUserQuery, GetMyUserQueryVariables>(GetMyUserDocument, options);
      }
export function useGetMyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyUserQuery, GetMyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyUserQuery, GetMyUserQueryVariables>(GetMyUserDocument, options);
        }
export type GetMyUserQueryHookResult = ReturnType<typeof useGetMyUserQuery>;
export type GetMyUserLazyQueryHookResult = ReturnType<typeof useGetMyUserLazyQuery>;
export type GetMyUserQueryResult = Apollo.QueryResult<GetMyUserQuery, GetMyUserQueryVariables>;
export const PropertiesDocument = gql`
    query Properties($sort: String, $limit: Int, $start: Int, $where: JSON) {
  properties(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...property
    agent {
      ...agent
      agency {
        ...agency
      }
    }
    suburb {
      ...suburb
      city {
        ...city
        province {
          ...province
        }
        district {
          ...district
        }
      }
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
}
    ${PropertyFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${ProvinceFragmentDoc}
${DistrictFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePropertiesQuery(baseOptions?: Apollo.QueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
      }
export function usePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
        }
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<typeof usePropertiesLazyQuery>;
export type PropertiesQueryResult = Apollo.QueryResult<PropertiesQuery, PropertiesQueryVariables>;
export const PropertyDocument = gql`
    query Property($id: ID!) {
  property(id: $id) {
    ...property
    suburb {
      ...suburb
      city {
        ...city
        province {
          ...province
        }
        district {
          ...district
        }
      }
    }
    agent {
      ...agent
      agency {
        ...agency
      }
    }
    rental_term {
      ...rentalTerm
    }
    property_category {
      ...propertyCategory
    }
    property_availability {
      ...propertyAvailability
    }
    type_of_property {
      ...typeOfProperty
    }
  }
}
    ${PropertyFragmentDoc}
${SuburbFragmentDoc}
${CityFragmentDoc}
${ProvinceFragmentDoc}
${DistrictFragmentDoc}
${AgentFragmentDoc}
${AgencyFragmentDoc}
${RentalTermFragmentDoc}
${PropertyCategoryFragmentDoc}
${PropertyAvailabilityFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyQuery(baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
      }
export function usePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
        }
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<typeof usePropertyLazyQuery>;
export type PropertyQueryResult = Apollo.QueryResult<PropertyQuery, PropertyQueryVariables>;
export const PropertyAvailabilitiesDocument = gql`
    query PropertyAvailabilities($sort: String, $limit: Int, $start: Int, $where: JSON) {
  propertyAvailabilities(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...propertyAvailability
  }
}
    ${PropertyAvailabilityFragmentDoc}`;

/**
 * __usePropertyAvailabilitiesQuery__
 *
 * To run a query within a React component, call `usePropertyAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyAvailabilitiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePropertyAvailabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<PropertyAvailabilitiesQuery, PropertyAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyAvailabilitiesQuery, PropertyAvailabilitiesQueryVariables>(PropertyAvailabilitiesDocument, options);
      }
export function usePropertyAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyAvailabilitiesQuery, PropertyAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyAvailabilitiesQuery, PropertyAvailabilitiesQueryVariables>(PropertyAvailabilitiesDocument, options);
        }
export type PropertyAvailabilitiesQueryHookResult = ReturnType<typeof usePropertyAvailabilitiesQuery>;
export type PropertyAvailabilitiesLazyQueryHookResult = ReturnType<typeof usePropertyAvailabilitiesLazyQuery>;
export type PropertyAvailabilitiesQueryResult = Apollo.QueryResult<PropertyAvailabilitiesQuery, PropertyAvailabilitiesQueryVariables>;
export const PropertyCategoriesDocument = gql`
    query propertyCategories($sort: String, $limit: Int, $start: Int, $where: JSON) {
  propertyCategories(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...propertyCategory
  }
}
    ${PropertyCategoryFragmentDoc}`;

/**
 * __usePropertyCategoriesQuery__
 *
 * To run a query within a React component, call `usePropertyCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyCategoriesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePropertyCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>(PropertyCategoriesDocument, options);
      }
export function usePropertyCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>(PropertyCategoriesDocument, options);
        }
export type PropertyCategoriesQueryHookResult = ReturnType<typeof usePropertyCategoriesQuery>;
export type PropertyCategoriesLazyQueryHookResult = ReturnType<typeof usePropertyCategoriesLazyQuery>;
export type PropertyCategoriesQueryResult = Apollo.QueryResult<PropertyCategoriesQuery, PropertyCategoriesQueryVariables>;
export const PropertyCategoryDocument = gql`
    query propertyCategory($id: ID!) {
  propertyCategory(id: $id) {
    ...propertyCategory
    properties {
      ...property
    }
  }
}
    ${PropertyCategoryFragmentDoc}
${PropertyFragmentDoc}`;

/**
 * __usePropertyCategoryQuery__
 *
 * To run a query within a React component, call `usePropertyCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyCategoryQuery(baseOptions: Apollo.QueryHookOptions<PropertyCategoryQuery, PropertyCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyCategoryQuery, PropertyCategoryQueryVariables>(PropertyCategoryDocument, options);
      }
export function usePropertyCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyCategoryQuery, PropertyCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyCategoryQuery, PropertyCategoryQueryVariables>(PropertyCategoryDocument, options);
        }
export type PropertyCategoryQueryHookResult = ReturnType<typeof usePropertyCategoryQuery>;
export type PropertyCategoryLazyQueryHookResult = ReturnType<typeof usePropertyCategoryLazyQuery>;
export type PropertyCategoryQueryResult = Apollo.QueryResult<PropertyCategoryQuery, PropertyCategoryQueryVariables>;
export const ProvincesDocument = gql`
    query Provinces($sort: String, $limit: Int, $start: Int, $where: JSON) {
  provinces(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...province
    districts {
      ...district
      cities {
        ...city
        suburbs {
          ...suburb
          properties {
            ...property
            suburb {
              ...suburb
              city {
                ...city
              }
            }
            rental_term {
              ...rentalTerm
            }
            type_of_property {
              ...typeOfProperty
            }
          }
        }
      }
    }
  }
}
    ${ProvinceFragmentDoc}
${DistrictFragmentDoc}
${CityFragmentDoc}
${SuburbFragmentDoc}
${PropertyFragmentDoc}
${RentalTermFragmentDoc}
${TypeOfPropertyFragmentDoc}`;

/**
 * __useProvincesQuery__
 *
 * To run a query within a React component, call `useProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvincesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProvincesQuery(baseOptions?: Apollo.QueryHookOptions<ProvincesQuery, ProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvincesQuery, ProvincesQueryVariables>(ProvincesDocument, options);
      }
export function useProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvincesQuery, ProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvincesQuery, ProvincesQueryVariables>(ProvincesDocument, options);
        }
export type ProvincesQueryHookResult = ReturnType<typeof useProvincesQuery>;
export type ProvincesLazyQueryHookResult = ReturnType<typeof useProvincesLazyQuery>;
export type ProvincesQueryResult = Apollo.QueryResult<ProvincesQuery, ProvincesQueryVariables>;
export const RentalTermsDocument = gql`
    query RentalTerms($sort: String, $limit: Int, $start: Int, $where: JSON) {
  rentalTerms(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...rentalTerm
  }
}
    ${RentalTermFragmentDoc}`;

/**
 * __useRentalTermsQuery__
 *
 * To run a query within a React component, call `useRentalTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalTermsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRentalTermsQuery(baseOptions?: Apollo.QueryHookOptions<RentalTermsQuery, RentalTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RentalTermsQuery, RentalTermsQueryVariables>(RentalTermsDocument, options);
      }
export function useRentalTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RentalTermsQuery, RentalTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RentalTermsQuery, RentalTermsQueryVariables>(RentalTermsDocument, options);
        }
export type RentalTermsQueryHookResult = ReturnType<typeof useRentalTermsQuery>;
export type RentalTermsLazyQueryHookResult = ReturnType<typeof useRentalTermsLazyQuery>;
export type RentalTermsQueryResult = Apollo.QueryResult<RentalTermsQuery, RentalTermsQueryVariables>;
export const SearchLocationDocument = gql`
    query SearchLocation($searchTerm: String!, $locationData: LocationDataInput) {
  searchLocation(searchTerm: $searchTerm, locationData: $locationData) {
    slug
    name
    _key
    typename
    district {
      ...district
    }
    city {
      ...city
      district {
        ...district
        province {
          ...province
        }
      }
    }
    province {
      ...province
    }
    __typename
  }
}
    ${DistrictFragmentDoc}
${CityFragmentDoc}
${ProvinceFragmentDoc}`;

/**
 * __useSearchLocationQuery__
 *
 * To run a query within a React component, call `useSearchLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      locationData: // value for 'locationData'
 *   },
 * });
 */
export function useSearchLocationQuery(baseOptions: Apollo.QueryHookOptions<SearchLocationQuery, SearchLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationQuery, SearchLocationQueryVariables>(SearchLocationDocument, options);
      }
export function useSearchLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationQuery, SearchLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationQuery, SearchLocationQueryVariables>(SearchLocationDocument, options);
        }
export type SearchLocationQueryHookResult = ReturnType<typeof useSearchLocationQuery>;
export type SearchLocationLazyQueryHookResult = ReturnType<typeof useSearchLocationLazyQuery>;
export type SearchLocationQueryResult = Apollo.QueryResult<SearchLocationQuery, SearchLocationQueryVariables>;
export const SuburbsDocument = gql`
    query Suburbs($sort: String, $limit: Int, $start: Int, $where: JSON) {
  suburbs(sort: $sort, limit: $limit, start: $start, where: $where) {
    city {
      district {
        province {
          country {
            ...country
          }
          ...province
        }
        ...district
      }
      ...city
    }
    ...suburb
  }
}
    ${CountryFragmentDoc}
${ProvinceFragmentDoc}
${DistrictFragmentDoc}
${CityFragmentDoc}
${SuburbFragmentDoc}`;

/**
 * __useSuburbsQuery__
 *
 * To run a query within a React component, call `useSuburbsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuburbsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuburbsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSuburbsQuery(baseOptions?: Apollo.QueryHookOptions<SuburbsQuery, SuburbsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuburbsQuery, SuburbsQueryVariables>(SuburbsDocument, options);
      }
export function useSuburbsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuburbsQuery, SuburbsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuburbsQuery, SuburbsQueryVariables>(SuburbsDocument, options);
        }
export type SuburbsQueryHookResult = ReturnType<typeof useSuburbsQuery>;
export type SuburbsLazyQueryHookResult = ReturnType<typeof useSuburbsLazyQuery>;
export type SuburbsQueryResult = Apollo.QueryResult<SuburbsQuery, SuburbsQueryVariables>;
export const TeamsDocument = gql`
    query Teams($sort: String, $limit: Int, $start: Int, $where: JSON) {
  teams(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...team
  }
}
    ${TeamFragmentDoc}`;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const TypeOfPropertiesDocument = gql`
    query TypeOfProperties($sort: String, $limit: Int, $start: Int, $where: JSON) {
  typeOfProperties(sort: $sort, limit: $limit, start: $start, where: $where) {
    ...typeOfProperty
  }
}
    ${TypeOfPropertyFragmentDoc}`;

/**
 * __useTypeOfPropertiesQuery__
 *
 * To run a query within a React component, call `useTypeOfPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTypeOfPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTypeOfPropertiesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *      start: // value for 'start'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTypeOfPropertiesQuery(baseOptions?: Apollo.QueryHookOptions<TypeOfPropertiesQuery, TypeOfPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TypeOfPropertiesQuery, TypeOfPropertiesQueryVariables>(TypeOfPropertiesDocument, options);
      }
export function useTypeOfPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TypeOfPropertiesQuery, TypeOfPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TypeOfPropertiesQuery, TypeOfPropertiesQueryVariables>(TypeOfPropertiesDocument, options);
        }
export type TypeOfPropertiesQueryHookResult = ReturnType<typeof useTypeOfPropertiesQuery>;
export type TypeOfPropertiesLazyQueryHookResult = ReturnType<typeof useTypeOfPropertiesLazyQuery>;
export type TypeOfPropertiesQueryResult = Apollo.QueryResult<TypeOfPropertiesQuery, TypeOfPropertiesQueryVariables>;